/* imods redesign 2026-09: shared behaviour for every page (SPEC §5, §12, §15, §18).
   Liquid renders every first state; this file only reacts. No "$" amounts are typed here: money comes in integer cents
   from variant data and is formatted by imods.money(). */
(function () {
  if (window.imods) return;
  var CFG = window.imodsConfig || {};
  var role = (window.Shopify && Shopify.theme && Shopify.theme.role) || 'main';
  var params = new URLSearchParams(location.search);
  // QA switches exist only on an unpublished theme (the test theme); the live theme ignores them.
  var QA = role !== 'main';
  var imods = {
    qa: QA,
    state: QA ? params.get('state') : null,
    returnsScope: (QA && params.get('qa_returns') === 'any') ? 'any_change' : (QA && params.get('qa_returns') === 'new') ? 'new_case' : (CFG.returnsScope || 'none')
  };
  window.imods = imods;

  // ---- money in integer cents, formatted with the store's own money format (G-13: no "$" typed in scripts)
  var MF = String(CFG.moneyFormat || '{{amount}}');
  (function () { try { var t = document.createElement('textarea'); t.innerHTML = MF; MF = t.value.replace(/<[^>]*>/g, ''); } catch (e) {} })();
  imods.money = function (cents) {
    if (cents == null || isNaN(cents)) return '';
    var neg = cents < 0; cents = Math.abs(Math.round(cents));
    function grp(n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    var d = Math.floor(cents / 100), c = String(cents % 100).padStart(2, '0'), whole = Math.round(cents / 100);
    var out = MF.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return grp(whole, ',');
      if (k === 'amount_with_comma_separator') return grp(d, '.') + ',' + c;
      if (k === 'amount_no_decimals_with_comma_separator') return grp(whole, '.');
      if (k === 'amount_with_apostrophe_separator') return grp(d, "'") + '.' + c;
      return grp(d, ',') + '.' + c;
    });
    return (neg ? '−' : '') + out;
  };
  imods.esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };

  // ---- feed fix (owner §284 + §287, 2026-11-03): Google's feed title = search title + variant title, and Google rejects promotional words
  // there, so the store's add-on values lose their "(... off ...)" words. The saving words live here, keyed by the plain value; the same
  // list is in snippets/imods-save-words.liquid (Liquid readers). A value that still carries its own "(... off ...)" keeps it, so the old
  // and the new store data show the same badges.
  var SAVE_WORDS = { '+ new battery': '5% off, 25% off with We Fix It', '+ 128gb flash mod service': '5% off', '+ 256gb flash mod service': '5% off',
    '+ center button': '5% off', '+ click wheel': '5% off', 'yes - new battery': '25% off' };
  var OWN_SAVE = /\(([^)]*\boff\b[^)]*)\)/i;
  imods.saveWords = function (v) {
    var m = OWN_SAVE.exec(v || ''); if (m) return m[1];
    return SAVE_WORDS[String(v || '').trim().toLowerCase()] || '';
  };
  // the value as the store wrote it before the feed fix (pickers that print the whole value)
  imods.saveLabel = function (v) {
    var s = String(v == null ? '' : v), w = imods.saveWords(s);
    return w && !OWN_SAVE.test(s) ? s + ' (' + w + ')' : s;
  };
  imods.$ = function (s, r) { return (r || document).querySelector(s); };
  imods.$$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // ---- one shared fetch of the menu data (builder, repair flow); never fetched twice, never embedded per widget
  var dataP = null;
  imods.data = function () {
    if (imods.state === 'load-error') return Promise.reject(new Error('QA load-error'));
    if (!dataP) {
      dataP = fetch(CFG.menus, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).catch(function (e) { dataP = null; throw e; });
    }
    return dataP;
  };

  // ---- DS-returns-line: one setting decides the final-sale rule. Owner ruling R-2026-09-26-02 (follow eoe): 'none' =
  // 30-day any-reason returns on everything, custom items included (the default). 'new_case' / 'any_change' are the
  // older rules, kept only for a future owner change. A completed repair is warranty only (R-2026-09-26-22).
  // QA only (unpublished theme): ?qa_returns=new or ?qa_returns=any shows the older rules.
  imods.RETURNS = {
    thirty: '30-day returns from delivery',
    finalSale: "Custom-built iPods and custom-color parts are final sale: they can't be returned for a change of mind, and a faulty one is still covered by our 1-year limited warranty.",
    repair: "Completed repairs aren't refundable. If a part we fitted fails within a year, we repair it again."
  };
  imods.isFinalSale = function (o) {
    o = o || {};
    if (o.repair) return false;
    if (imods.returnsScope === 'none') return false;
    if (o.customColourPart) return true;
    if (o.newCase) return true;
    if (imods.returnsScope === 'any_change' && (o.flash || o.battery2000)) return true;
    return false;
  };

  // ---- "Your iPod", remembered for this visit only (D-11 A: sessionStorage, no cookie)
  var YK = 'imods.yourIpod';
  imods.yours = {
    get: function () { try { return JSON.parse(sessionStorage.getItem(YK) || 'null'); } catch (e) { return null; } },
    set: function (v) { try { sessionStorage.setItem(YK, JSON.stringify(v)); } catch (e) {} imods.yours.render(); document.dispatchEvent(new CustomEvent('imods:yours', { detail: v })); },
    clear: function () { try { sessionStorage.removeItem(YK); } catch (e) {} imods.yours.render(); document.dispatchEvent(new CustomEvent('imods:yours', { detail: null })); },
    render: function () {
      var v = imods.yours.get();
      imods.$$('[data-im-yours]').forEach(function (el) {
        var label = el.querySelector('[data-im-yours-label]');
        if (v && v.label) { if (label) label.textContent = v.label; el.hidden = false; } else { el.hidden = true; }
      });
    }
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-im-yours-clear]');
    if (b) { e.preventDefault(); imods.yours.clear(); }
  });
  // B11 iPod Repair menu: a tab or the phone select the visitor picks wins over "Your iPod"; the select drives the hidden tabs
  document.addEventListener('change', function (e) {
    var t = e.target, m = t.closest && t.closest('[data-im-mrx]');
    if (!m) return;
    if (t.matches('[data-im-mrx-select]')) { var r = m.querySelector('.im-mrx-r[value="' + t.value + '"]'); if (r) r.checked = true; }
    if (t.matches('[data-im-mrx-select], .im-mrx-r')) { m.setAttribute('data-touched', ''); imods.mrxSync(m); }
  });
  // menus round 2 (R2-4c, owner §30; built 2026-10-17): the iPod Repair boxes open one at a time (<details name> does it natively; this
  // covers browsers without it), and on a phone the box that was open stays open when another iPod is picked (the mock's rule)
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('.im-mrx-box') || !d.open) return;
    var m = d.closest('[data-im-mrx]'); if (!m) return;
    imods.$$('.im-mrx-box[open]', m).forEach(function (x) { if (x !== d) x.removeAttribute('open'); });
    m.__boxI = d.getAttribute('data-i');
  }, true);
  imods.mrxSync = function (m) {
    if (!m.classList.contains('im-mr--phone')) return;
    var r = m.querySelector('.im-mrx-r:checked'), g = r && m.querySelector('.im-mrx-grid[data-fam="' + r.value + '"]');
    if (!g || g.querySelector('.im-mrx-box[open]') || m.querySelector('.im-mrx-acc .im-mrx-box[open]')) return;
    var i = m.__boxI == null ? '0' : m.__boxI;
    var b = g.querySelector('.im-mrx-box[data-i="' + i + '"]') || g.querySelector('.im-mrx-box'); if (b) b.setAttribute('open', '');
  };

  // ---- header: panels overlay the page; open by click, tap, keyboard (native details) and by hover with a pointer.
  // G-05: a panel closes when focus leaves it; Escape closes it and returns focus to its summary.
  function initNav() {
    var nav = imods.$('[data-im-nav]');
    if (!nav) return;
    var items = imods.$$('details[data-im-mega]', nav);
    function closeAll(except) { items.forEach(function (d) { if (d !== except) d.removeAttribute('open'); }); }
    // FIX-2 (O-1 A): an open panel never runs past the screen edge (it scrolls inside, with a "More below" cue) and the
    // chat button never sits over it (if they would meet, the button hides until the panel closes)
    function fitPanel() {
      var d = items.filter(function (x) { return x.open; })[0], panel = d && d.querySelector('.im-panel');
      document.body.classList.remove('im-panel-over-chat');
      if (!panel || !window.matchMedia('(min-width: 990px)').matches) return;
      panel.style.setProperty('--im-panel-max', Math.max(160, Math.floor(window.innerHeight - panel.getBoundingClientRect().top)) + 'px');
      panel.classList.toggle('is-more', panel.scrollHeight > panel.clientHeight + 2 && panel.scrollTop + panel.clientHeight < panel.scrollHeight - 2);
      // design round 3 (F1, 2026-10-17): the launcher sits two shadow levels down now; chatButton() below searches them
      var btn = null;
      try { btn = chatButton(); } catch (err) {}
      var br = btn && btn.getBoundingClientRect(), pr = panel.getBoundingClientRect();
      if (br && br.width && br.top < pr.bottom && br.bottom > pr.top && br.left < pr.right && br.right > pr.left) document.body.classList.add('im-panel-over-chat');
    }
    var fitRaf = 0;
    function fitSoon() { if (!fitRaf) fitRaf = requestAnimationFrame(function () { fitRaf = 0; fitPanel(); }); }
    imods.fitPanel = fitPanel;
    window.addEventListener('resize', fitSoon);
    document.addEventListener('imods:menus-ready', fitSoon);
    items.forEach(function (d) {
      var panel = d.querySelector('.im-panel');
      if (panel) panel.addEventListener('scroll', fitSoon, { passive: true });
      ['click', 'keyup', 'input'].forEach(function (ev) { d.addEventListener(ev, fitSoon); });
      d.addEventListener('toggle', function () { fitSoon(); if (d.open) { closeAll(d); imods.menus.ensure(); } });
      var t = null, s = d.querySelector('summary');
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        // FIX-3 N-10: most people rest on a label (hover opens it) and then click it; the native details toggle would shut
        // the panel they just saw open. The first mouse click on a label that hover opened keeps it open (a second click
        // closes it, as live's click-only menus do). Keyboard clicks (detail 0) and taps keep the native toggle.
        var byHover = false;
        d.addEventListener('toggle', function () { if (!d.open) byHover = false; });
        s.addEventListener('click', function (e) { if (byHover && d.open && e.detail > 0) { e.preventDefault(); byHover = false; } });
        // sitting 2 (owner §65-§68): the Featured Services pill opens its menu when the pointer rests anywhere on it (both buttons)
        var hov = d.closest('[data-im-feat]') || d;
        hov.addEventListener('mouseenter', function () { imods.menus.ensure(); clearTimeout(t); t = setTimeout(function () { if (!d.open) { byHover = true; d.setAttribute('open', ''); } }, 120); });
        hov.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { if (!d.contains(document.activeElement) || document.activeElement === d.querySelector('summary')) d.removeAttribute('open'); }, 220); });
      }
      ['focus', 'touchstart', 'pointerdown'].forEach(function (ev) { s.addEventListener(ev, function () { imods.menus.ensure(); }, { passive: true }); });
      d.addEventListener('focusout', function (e) { if (d.open && e.relatedTarget && !d.contains(e.relatedTarget)) d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || e.defaultPrevented) return;
      var open = items.filter(function (d) { return d.open; })[0];
      if (open) { open.removeAttribute('open'); var s = open.querySelector('summary'); if (s) s.focus(); }
    });
    document.addEventListener('click', function (e) { if (e.target.isConnected && !nav.contains(e.target)) closeAll(null); });
    // 2026-10-24 (owner: "Should we add a close menu button on the mega menu for users to more easily close this large menu?"): a
    // visible close button at the top right of every panel (Escape and a click outside still close it); put back if a menu script
    // rebuilds the panel's content
    items.forEach(function (d) {
      var panel = d.querySelector('.im-panel'), s = d.querySelector('summary'); if (!panel) return;
      var name = s ? s.textContent.replace(/\s+/g, ' ').trim() : 'this';
      function put() {
        if (panel.querySelector(':scope > .im-panel__close')) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'im-panel__close'; b.setAttribute('aria-label', 'Close the ' + name + ' menu'); b.title = 'Close';
        b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); d.removeAttribute('open'); if (s) s.focus(); });
        panel.insertBefore(b, panel.firstChild);
      }
      put();
      if (window.MutationObserver) new MutationObserver(put).observe(panel, { childList: true });
    });
  }

  // ---- phone drawer; G-04: body.im-drawer-open hides the chat button (tokens CSS) while the drawer is open
  function initDrawer() {
    var dr = imods.$('[data-im-drawer]');
    if (!dr) return;
    var summary = dr.querySelector('summary');
    dr.addEventListener('toggle', function () {
      var h = document.querySelector('.section-header');
      var r = h ? h.getBoundingClientRect() : null;
      document.documentElement.style.setProperty('--im-drawer-top', (r ? Math.max(0, r.bottom) : 102) + 'px');
      document.body.classList.toggle('im-drawer-open', dr.open);
      summary.setAttribute('aria-expanded', dr.open ? 'true' : 'false');
      if (dr.open) { imods.menus.ensure(); var first = dr.querySelector('.im-drawer__panel a, .im-drawer__panel summary'); if (first) first.focus(); }
    });
    imods.$$('details[data-im-mega]', dr).forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) imods.menus.ensure(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dr.open && !e.defaultPrevented) { dr.removeAttribute('open'); summary.focus(); }
    });
  }

  // ---- menus round 2 (2026-10-17; owner I-13 "select all details of the iPod and then the button would appear", marks §27 R2-2):
  // Build your iPod's unit rule, ONE copy shared by the builder (assets/imods-builder.js) and the Shop iPods menu (deskShop/phoneShop
  // below). Moved here unchanged from imods-builder.js (prestate sym_build1/prestate/menusr2/pre/assets/imods-builder.js); the builder
  // keeps its own names as thin wrappers. The exact store unit is chosen for the buyer: the lowest price among the eligible units of
  // that colour; the 30GB 5th Gen stops at its rules cap30.max flash (256GB, owner C-2) and at 32 MB songs; 2000mAh with flash only
  // (5th-7th Gen); the 1200mAh on any storage (4th Gen / Photo); no U2 on the 4th Gen / Photo; HP Invent its own choice. A context
  // c = { D: the menu data (ipodkb-menus.json), R: the rules block (#imods-rules on the builder; the menu data's copy D.rules in the
  // menu), fam: the model key, songs: the library size the builder asks (0 in the menu) }. Prices stay as the data holds them (the
  // builder converts units to cents in place; read them with v._c in mind).
  imods.units = (function () {
    function capOf(v) { var m = /(\d+)\s?(GB|TB)/i.exec(v || ''); return m ? { label: m[1] + m[2].toUpperCase(), gb: (+m[1]) * (m[2].toUpperCase() === 'TB' ? 1024 : 1) } : null; }
    function isFlash(v) { return /flash|included/i.test(v || ''); }
    function is2000(v) { return /2000/.test(v || ''); }
    function is1200(v) { return /1200/.test(v || ''); }   // round 1 (G-08): 4th Gen / Photo 1200mAh extended-life battery, any storage
    function isNew(v) { return /^(brand new|new case)/i.test(v || ''); }   // round 1 (I-15): old and new store names
    function edition(u) { return /U2/.test(u.title) ? (/Color/.test(u.title) ? 'U2 Color Edition' : 'U2 Special Edition') : (/HP/.test(u.title) ? 'HP Invent' : ''); }
    // the colour choice: the case colour, or the named edition (U2); HP Invent is its own choice (an HP-branded white iPod)
    function colorKey(u) { var e = edition(u); return /^U2/.test(e) ? e : (e === 'HP Invent' ? (u.color || '') + ' · HP Invent' : (u.color || '')); }
    // FIX-8: the flash-build products (no colour; the 6th Gen one carries cap "128GB flash mod") are never offered as a unit here
    function isFlashBuild(u) { return /flash-storage modded|flash-storage|flash-mod-refurbished/i.test(u.title + ' ' + u.handle) && (!u.cap || isFlash(u.cap)); }
    function keysOf(u) {
      var ks = Object.keys((u.variants[0] || { so: {} }).so || {});
      return { cond: u.condname && ks.indexOf(u.condname) >= 0 ? u.condname : null, bat: ks.indexOf('Battery') >= 0 ? 'Battery' : null,
               sto: ks.filter(function (k) { return /storage|capacity/i.test(k); })[0] || null };
    }
    function vals(u, key) { var out = []; if (!key) return out; u.variants.forEach(function (v) { var x = v.so[key]; if (x != null && out.indexOf(x) < 0) out.push(x); }); return out; }
    function famRules(c) { return (c.R.storage || {})[c.fam] || {}; }
    function guard2000(c) { return ((c.R.battery2000 || {}).families || []).indexOf(c.fam) >= 0; }
    function is30(c, u) { return c.fam === '5G' && /^30GB/i.test(u.cap || ''); }
    // FIX-9 set 6 (owner NAV-R106-1, "remove U2 as option from color for 4G and photo"; asked again 2026-09-28): the U2
    // editions are not offered here for the 4th Gen and Photo (the menus already leave them out); their own pages are unchanged
    function noU2(c, u) { return !((c.fam === '4G' || c.fam === 'Photo') && /^U2/.test(edition(u))); }
    function units(c) { return ((c.D.units || {})[c.fam] || []).filter(function (u) { return !isFlashBuild(u) && noU2(c, u) && u.variants.some(function (v) { return v.avail; }); }); }
    // plain colours first, then the editions (U2, HP Invent), each in the store's order
    function colors(c) { var out = []; units(c).forEach(function (u) { var k = colorKey(u); if (out.indexOf(k) < 0) out.push(k); }); return out.filter(function (k) { return !/U2|HP Invent/.test(k); }).concat(out.filter(function (k) { return /U2|HP Invent/.test(k); })); }
    function stdBat(u) { var bs = vals(u, keysOf(u).bat); return bs.filter(function (b) { return !is2000(b) && !is1200(b); })[0] || bs[0] || null; }
    function batVal(u, kind) { var bs = vals(u, keysOf(u).bat); return kind === '2000' ? (bs.filter(is2000)[0] || null) : (kind === '1200' ? (bs.filter(is1200)[0] || null) : stdBat(u)); }
    function condVal(u, neu) { var cs = vals(u, keysOf(u).cond); return neu ? (cs.filter(isNew)[0] || null) : (cs.filter(function (x) { return !isNew(x); })[0] || cs[0] || null); }
    function hasNewCase(c) { return units(c).some(function (u) { return !!condVal(u, true) && (u.finish_pairs || []).length; }); }
    function find(u, cond, sto, bat) {
      var k = keysOf(u);
      for (var i = 0; i < u.variants.length; i++) {
        var v = u.variants[i], so = v.so;
        if (k.cond && cond != null && so[k.cond] !== cond) continue;
        if (k.sto && sto != null && so[k.sto] !== sto) continue;
        if (k.bat && bat != null && so[k.bat] !== bat) continue;
        return v;
      }
      return null;
    }
    function offered(c, u, v) {
      if (!v || !v.avail) return false;
      var k = keysOf(u);
      if (guard2000(c) && k.bat && is2000(v.so[k.bat]) && k.sto && !isFlash(v.so[k.sto])) return false;
      return true;
    }
    // the storage choices for a colour: {key, label, flash, gb, price, unit, raw, v, cond}; the unit is chosen for the buyer
    // (lowest price; the 5th Gen 30GB units only up to their rules cap30.max flash, 256GB since owner C-2; on a tie the 64 MB unit
    // wins for flash; with more songs than 32 MB holds, the build moves to a 64 MB unit)
    function storageOpts(c, color, neu, batKind) {
      var fr = famRules(c), allowed = fr.flashAllowed, max30 = fr.cap30 ? capOf(fr.cap30.max).gb : 0;
      var need64 = c.fam === '5G' && parseInt(c.songs, 10) > (c.R.memory || {}).songs32;
      var opts = {};
      units(c).filter(function (u) { return colorKey(u) === color; }).forEach(function (u) {
        var k = keysOf(u), cond = condVal(u, neu); if (neu && !cond) return;
        vals(u, k.sto).forEach(function (s) {
          var cp = capOf(s); if (!cp) return;
          var fl = isFlash(s);
          if (fl && allowed && allowed.indexOf(cp.label) < 0) return;
          if (!fl && s !== u.cap) return;
          if (fl && is30(c, u) && (cp.gb > max30 || need64)) return;
          var b = batVal(u, (fl || batKind === '1200') ? batKind : 'std') || stdBat(u);   // the 2000mAh: flash builds only; the 1200mAh: any storage
          var v = find(u, cond, s, b);
          if (!offered(c, u, v)) return;
          var key = (fl ? 'f' : 'h') + cp.gb, o = opts[key];
          if (!o || v.price < o.price || (v.price === o.price && fl && is30(c, o.unit) && !is30(c, u))) opts[key] = { key: key, label: cp.label, flash: fl, gb: cp.gb, price: v.price, unit: u, raw: s, v: v, cond: cond };
        });
      });
      return Object.keys(opts).map(function (k) { return opts[k]; }).sort(function (a, b) { return (a.flash - b.flash) || (a.gb - b.gb); });
    }
    // the battery kinds an iPod's units offer: the standard one always, the 2000mAh (5th-7th Gen, with flash) and the 1200mAh (4th Gen /
    // Photo) where its units carry them (the Shop iPods menu's Battery row; the builder reads the rules block for its own row)
    function batKinds(c) {
      var out = ['std'];
      units(c).forEach(function (u) { vals(u, keysOf(u).bat).forEach(function (b) { var k = is2000(b) ? '2000' : (is1200(b) ? '1200' : null); if (k && out.indexOf(k) < 0) out.push(k); }); });
      return out;
    }
    return { capOf: capOf, isFlash: isFlash, is2000: is2000, is1200: is1200, isNew: isNew, edition: edition, colorKey: colorKey, isFlashBuild: isFlashBuild,
             keysOf: keysOf, vals: vals, famRules: famRules, guard2000: guard2000, is30: is30, noU2: noU2, units: units, colors: colors, stdBat: stdBat,
             batVal: batVal, condVal: condVal, hasNewCase: hasNewCase, find: find, offered: offered, storageOpts: storageOpts, batKinds: batKinds };
  })();

  // ---- the owner's individual colour model pictures (2026-10-23: "we are not utilizing our individual color model images for all
  // applicable pages (example: build your iPod)"): snippets/imods-cb-fronts prints {"<family>": {"": default front, "<colour word>":
  // picture}} for the eight iPods the store sells. fronts(fam) = the model's default front; fronts(fam, colour) = that colour's picture
  // (the first word of the store's colour name, lower case: "Black", "Silver", "White · HP Invent" -> white), or null when there is
  // none (a U2 edition): the caller keeps its own picture. Build your iPod and the Shop iPods menu use it for a chosen colour, the My
  // iPod chip for the visitor's own iPod; models and model lists keep their family pictures (owner, 2026-10-23 evening).
  imods.fronts = (function () {
    var J = null;
    return function (fam, colour) {
      if (J === null) { try { J = JSON.parse((document.getElementById('imods-fronts') || {}).textContent || '{}') || {}; } catch (e) { J = {}; } }
      var m = J[fam];
      if (!m) return null;
      if (!colour) return m[''] || null;
      return m[String(colour).toLowerCase().split(/[\s·\/]+/)[0]] || null;
    };
  })();

  // ---- mega-panel functions from the live menus (G-01; SPEC §5, §18), rebuilt in the new design. The menu data loads on
  // intent only, through the one shared imods.data() fetch; the Liquid links stay in place until it arrives and whenever it
  // fails. Routing only (rounds 121/122): no Add to cart and no thin/thick pop-over here. Money in integer cents.
  imods.menus = (function () {
    var D = null, started = false, done = false;
    // FIX-7 (R-2026-09-27-01 "Tight tiles"): the Parts tiles and the phone drawer's model grid use the name without "iPod"
    // (the photo and the model number sit beside it); everything else keeps SHORT
    var TILE = { '3G': 'iPod 3rd Gen', '4G': 'iPod 4th Gen', Photo: 'iPod Photo', '5G': 'Video 5th Gen', '6G': 'Classic 6th Gen', '7G': 'Classic 7th Gen', Mini1: 'Mini 1st Gen', Mini2: 'Mini 2nd Gen' };
    var SHORT = { '3G': 'iPod 3rd Gen', '4G': 'iPod 4th Gen', Photo: 'iPod Photo', '5G': 'iPod Video 5th Gen', '6G': 'iPod Classic 6th Gen', '7G': 'iPod Classic 7th Gen', Mini1: 'iPod Mini 1st Gen', Mini2: 'iPod Mini 2nd Gen' };
    // menus round 2: + the editions the Shop iPods card shows as colour choices (the builder's own swatches)
    var SW = { White: '#f3f3f5', Black: '#1d1d1f', Silver: '#c7c7cc', Blue: '#3d7fd6', Green: '#5fbf6a', Pink: '#f08bb8', Gold: '#d6b56b', Red: '#d33a2f', Gray: '#8e8e93', Purple: '#8a63d2', Yellow: '#f2cf3f', Orange: '#f28b30', Charcoal: '#3a3a3c',
      'White · HP Invent': 'linear-gradient(135deg,#f3f3f5 60%,#0096d6 60%)', 'U2 Special Edition': 'linear-gradient(135deg,#1d1d1f 60%,#d33a2f 60%)', 'U2 Color Edition': 'linear-gradient(135deg,#1d1d1f 60%,#d33a2f 60%)' };
    var ICON = { 'Battery': 'battery', 'Screen': 'screen', 'Hard Drive': 'hard-drive', 'Click Wheel': 'click-wheel', 'Headphone Jack': 'headphone-jack', 'Logic Board': 'logic-board', 'Faceplate': 'faceplate', 'Backplate': 'backplate', 'Flash Mod': 'flash-mod' };
    // the live loader's "from" rules: price only the part itself, not its cables, bezels or center buttons
    var COMP_RX = { 'Hard Drive': [/\d+\s?(GB|TB)/i, /cable|bumper|insulator|ribbon|spacer/i], 'Click Wheel': [/click wheel/i, /cent(er|re) button/i], 'Headphone Jack': [/headphone/i, /bezel|bracket/i], 'Screen': [/lcd|screen|display/i, /lens|glass|film/i], 'Backplate': [/backplate|rear panel|back plate/i, /bezel|clip/i], 'Faceplate': [/faceplate|front panel/i, /lens|bezel/i], 'Battery': [/battery/i, /terminal|connector/i], 'Logic Board': [/logic board|motherboard/i, /component|chip/i] };
    // page context (live round 117): the model and part of the page you are on
    var FAMRX = [['Photo', /photo-4th|4th-generation-photo|ipod-photo/], ['3G', /3rd-generation|-3g-/], ['4G', /4th-generation|-4g-/], ['5G', /video-5th|5th-generation|-5g-/], ['6G', /6th-generation|-6g-/], ['7G', /7th-generation|-7g-/], ['Mini1', /mini-1st|1st-generation-mini/], ['Mini2', /mini-2nd|2nd-generation-mini/]];
    var PARTRX = [['Battery', /battery/], ['Screen', /screen|lcd|display/], ['Hard Drive', /hard-drive|microdrive|hdd/], ['Click Wheel', /click-wheel/], ['Headphone Jack', /headphone-jack/], ['Logic Board', /logic-board/], ['Faceplate', /faceplate|front-panel/], ['Backplate', /backplate|rear-panel|back-plate/], ['Flash Mod', /flash-mod/]];
    var MEM = { fam: null, part: null, ctxFam: null };

    var esc = imods.esc, money = imods.money;
    function cOf(v) { return v._c ? v.price : Math.round(Number(v.price) * 100); } // the builder converts unit prices in place (flag _c)
    function isInst(n) { return /install/i.test(n); }
    // an installation option value means "installed" when it starts with "Yes" or reads "Professional installation"
    // (the 4th Gen front panel; the live loader missed that one and showed "Installed" with no price)
    function yesInst(v) { return /^yes|professional installation/i.test(v || ''); }
    function name(t) { return String(t || '').replace(/\s&\s/g, ' and '); } // SPEC §0: no "&" in names (G-09)
    function fams() { return (D.fam || []).filter(function (f) { return SHORT[f.k]; }); }
    function context() {
      var path = location.pathname.toLowerCase();
      if (!/^\/(collections|products)\//.test(path)) return;
      var seg = path.replace(/^\/(collections|products)\//, '');
      for (var i = 0; i < FAMRX.length; i++) if (FAMRX[i][1].test(seg)) { MEM.fam = MEM.ctxFam = FAMRX[i][0]; break; }
      if (/^\/products\//.test(path) || /^[^/]*(replacement|flash-mods)/.test(seg) || seg.indexOf('/') >= 0) {
        for (var j = 0; j < PARTRX.length; j++) if (PARTRX[j][1].test(seg)) { MEM.part = PARTRX[j][0]; break; }
      }
    }
    function yours() { var y = imods.yours.get(); return y && y.key && SHORT[y.key] ? y.key : null; }
    // the part icons come from the page's one sprite (snippets/imods-icon-sprite.liquid), not from the menu data
    function icon(slug) { return '<svg class="im-ico im-pi" viewBox="0 0 48 48" width="24" height="24" aria-hidden="true" focusable="false"><use href="#ipi-' + slug + '"/></svg>'; }
    function driveOnly(part, ps) { var rx = COMP_RX[part]; if (!rx) return ps; var d = ps.filter(function (q) { return rx[0].test(q.title) && !rx[1].test(q.title); }); return d.length ? d : ps; }
    function low(ps, installed) {
      var best = null;
      ps.forEach(function (q) {
        var ii = -1; q.options.forEach(function (o, i) { if (ii < 0 && isInst(o.name)) ii = i; });
        q.variants.forEach(function (v) {
          if (!v.available) return;
          if (ii >= 0 && yesInst(v.o[ii]) !== installed) return;
          var c = cOf(v); if (best == null || c < best) best = c;
        });
      });
      return best;
    }
    function productUrl(q, installed) {
      var ii = -1; q.options.forEach(function (o, i) { if (ii < 0 && isInst(o.name)) ii = i; });
      var v = q.variants.filter(function (v) { return v.available && (ii < 0 || yesInst(v.o[ii]) === installed); })[0];
      return '/products/' + (q.url_handle || q.handle) + (v ? '?variant=' + v.id : '');
    }
    // FIX-3 N-11: the flash kits are split per capacity in the menu data but are ONE product per model; a link to the
    // all-kits collection made the visitor pick the model again. Rows of one product go to that product, on the variant
    // that carries the tile's price (part only, or installed).
    function oneProduct(ps) { var h = ps[0].url_handle || ps[0].handle; return ps.every(function (q) { return (q.url_handle || q.handle) === h; }); }
    function cheapestUrl(ps, installed) {
      var best = null, id = null;
      ps.forEach(function (q) {
        var ii = -1; q.options.forEach(function (o, i) { if (ii < 0 && isInst(o.name)) ii = i; });
        q.variants.forEach(function (v) {
          if (!v.available || (ii >= 0 && yesInst(v.o[ii]) !== installed)) return;
          var c = cOf(v); if (best == null || c < best) { best = c; id = v.id; }
        });
      });
      return '/products/' + (ps[0].url_handle || ps[0].handle) + (id ? '?variant=' + id : '');
    }
    // FIX-10 set 2, NAV-R78-1a (owner 2026-09-29: the Mini housing "represents the outer casing like the other models"): the
    // Mini 1st and 2nd Gen have no faceplate or backplate of their own; their Faceplate and Backplate rows price and link the
    // Mini housings (menu data key "housing", read by the menus only; Start your repair keeps D.pp as it is)
    function housing(part, k) {
      if (part !== 'Faceplate' && part !== 'Backplate') return null;
      if ((D.pp[part + '|' + k] || []).length) return null;
      var h = D.housing && D.housing[k]; return h && h.length ? h : null;
    }
    var PFKEY = { 'Battery': 'battery', 'Screen': 'screen', 'Hard Drive': 'hard-drive', 'Click Wheel': 'click-wheel', 'Headphone Jack': 'headphone-jack', 'Logic Board': 'logic-board', 'Faceplate': 'faceplate', 'Backplate': 'backplate', 'Flash Mod': 'flash-mod' };
    function psOf(part, k) { return housing(part, k) || D.pp[part + '|' + k] || []; }
    function route(part, f, installed) {
      if (housing(part, f.k)) return f.parts + '/housing'; // the family page with its Housing group picked (FIX-8 part-type address)
      var ps = D.pp[part + '|' + f.k] || []; if (!ps.length) return null;
      if (ps.length === 1) return productUrl(ps[0], installed);
      if (oneProduct(ps)) return cheapestUrl(ps, installed);
      // FIX-10 set 6 (census C1, owner 2026-09-30): several of this part for this iPod -> the iPod's parts page opened at
      // the part (rows with Add part and Installed), where the Repair menu and the part-type pages land; no longer the old
      // chooser page (/collections/ipod-<part>-replacement/<model>?install=), which opened on another part's price
      return f.parts + '/' + PFKEY[part];
    }
    // UX round 2 (owner 2026-10-02, single-destination rule): the menus land on ONE page per iPod + part. D.sib (static menu data,
    // sym_build1/tools/ux2_menu_data.py) lists that part's products for the iPod, host first: one = its own product page; several = the
    // chooser (/products/<host>?view=choose), where the visitor picks width, version, capacity or color. Part and Installed open it
    // with that option picked (?variant= = the plain part-only or installed variant: no add-on, no box). Parts pages keep every product.
    function sibRows(part, k) {
      var hs = D.sib && D.sib[part + '|' + k]; if (!hs || !hs.length) return null;
      var rows = (D.pp[part + '|' + k] || []).length ? D.pp[part + '|' + k] : ((D.housing && D.housing[k]) || []);
      rows = rows.filter(function (q) { return hs.indexOf(q.url_handle || q.handle) >= 0; });
      return rows.length ? { hs: hs, rows: rows } : null;
    }
    function noneVal(v) { return /^(none|no|default title)$/i.test(v || '') || /part only|\(included\)/i.test(v || ''); }
    function plainVariant(q, installed) {
      var ii = -1; q.options.forEach(function (o, i) { if (ii < 0 && isInst(o.name)) ii = i; });
      if (ii < 0 && installed) return null;
      return q.variants.filter(function (v) {
        return v.available && v.o.every(function (val, i) { return i === ii ? (yesInst(val) === installed && !(installed && /box|label/i.test(val))) : noneVal(val); });
      })[0] || null;
    }
    function sibInfo(part, f, installed) {
      var s = sibRows(part, f.k); if (!s) return null;
      var best = null, no2000 = function (h) { return !installed && /2000mah/i.test(h); };   // the 2000mAh battery is installed only (FIX-9)
      s.rows.forEach(function (q) { if (no2000(q.url_handle || q.handle)) return; var v = plainVariant(q, installed); if (v && (best == null || cOf(v) < best)) best = cOf(v); });
      var host = s.hs[0], hq = s.rows.filter(function (q) { return (q.url_handle || q.handle) === host; })[0];
      var hv = hq && !no2000(host) ? plainVariant(hq, installed) : null, many = s.hs.length > 1;
      // sitting 2 (2026-10-25, owner §57/§58 Parts polish): "from $X" instead of a trailing "+" where several products or options share the iPod + part
      var txt = best == null ? null : money(best), from = s.rows.length > 1;
      // UX round 3 (owner 2026-10-02): several products -> the general page of the iPod + part (/collections/<collection>/<iPod tag>,
      // D.sibu); Installed adds ?fix=installed (the page picks We Fix It); nothing is pre-picked there
      var gen = many && D.sibu && D.sibu[part + '|' + f.k];
      if (gen) return { page: gen, txt: txt, from: from, href: installed ? gen + '?fix=installed' : gen };
      var page = '/products/' + host + (many ? '?view=choose' : '');
      return { page: page, txt: txt, from: from, href: hv ? page + (many ? '&' : '?') + 'variant=' + hv.id : page };
    }
    // the row's model name: that part's page for the iPod (the chooser when there are several), else the iPod's parts page
    function rowHref(part, f, any) { var si = any && sibInfo(part, f, false); return si ? si.page : f.parts; }
    function rowLabel(part, f, any, m) { return SHORT[f.k] + ' ' + (any && sibRows(part, f.k) ? (housing(part, f.k) ? 'housing' : m.label.toLowerCase()) : 'parts'); }
    // the "from" price of a part for one iPod, part only or installed, and where it links (null when there is none)
    function priceFor(part, f, installed) {
      var si = sibInfo(part, f, installed);
      if (si) return si.txt ? { txt: si.txt, from: si.from, href: si.href } : null;
      var ps = psOf(part, f.k); if (!ps.length) return null;
      var c = low(driveOnly(part, ps), installed); if (c == null) return null;
      return { txt: money(c), from: ps.length > 1, href: route(part, f, installed) };
    }
    // "Your iPod" (D-11 A) and the page's own model: every [data-k] is marked; a [data-im-tagslot] inside it holds the tag
    function mark(host) {
      var y = yours();
      imods.$$('[data-k]', host).forEach(function (el) {
        var k = el.getAttribute('data-k');
        el.classList.toggle('is-on', k === MEM.fam);
        el.classList.toggle('is-yours', k === y);
        var slot = el.querySelector('[data-im-tagslot]');
        if (slot) slot.innerHTML = k === y ? '<span class="im-tag">Your iPod</span>' : '';
      });
    }
    // owner R-2026-09-26-12: the small model photos are in the menu tiles, with one "representative photos" note per menu
    var REP = '<span class="im-m-rep">Representative photos</span>';
    function pic(f, w) { if (!f || !f.img) return ''; var u = String(f.img).replace(/([?&])width=\d+/, '$1width=' + w); return '<img class="im-m-pic" src="' + esc(u) + '" alt="' + esc((SHORT[f.k] || f.sl || '') + (f.no ? ' (' + f.no + ')' : '')) + '" width="48" height="48" loading="lazy" decoding="async">'; }
    function mico(slug) { return '<svg class="im-ico im-pi im-m-ico" viewBox="0 0 48 48" width="22" height="22" aria-hidden="true" focusable="false"><use href="#ipi-' + slug + '"/></svg>'; }
    function refit() { if (imods.fitPanel) requestAnimationFrame(function () { imods.fitPanel(); }); }
    var BUILD = '/collections/ipods-for-sale?panel=create&model=', DIAG = '/products/free-ipod-diagnostic-service';
    // FIX-10 set 6 (census C3, owner 2026-09-30): the Shop menu's builder links open AT Build your iPod (#build, as the hub's
    // cards), so the choices, the price and Add to cart are on screen instead of the hub's top
    function atBuild(h) { return h + '#build'; }
    // nav round 2026-10-21 (planning session's refined plan, item 4; timing as its mockup 10; the owner marks it in the before/after
    // round): diagonal hover intent ("menu aim") on the Shop tabs, the Parts rail and the By iPod rail. A pointer heading from an item into
    // its panel crosses other items on the way. While it keeps moving inside the triangle between where it was a few moves ago and the
    // panel's near edge (24 px of slack), a newly hovered item waits; it shows once the pointer rests 70 ms (as before), leaves the
    // triangle, or gets no closer to the panel for 250 ms. Focus, the arrow keys and clicks (S10: a click or Enter opens the page) act
    // at once, as before.
    var AIM = { pts: [], at: 0, on: false };
    function aimTrack() {
      if (AIM.on) return;
      AIM.on = true;
      document.addEventListener('mousemove', function (e) { AIM.pts.push({ x: e.clientX, y: e.clientY }); if (AIM.pts.length > 5) AIM.pts.shift(); AIM.at = Date.now(); }, { passive: true });
    }
    function inTri(p, a, b, c) {
      var s = function (p1, p2, p3) { return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y); };
      var d1 = s(p, a, b), d2 = s(p, b, c), d3 = s(p, c, a);
      return !((d1 < 0 || d2 < 0 || d3 < 0) && (d1 > 0 || d2 > 0 || d3 > 0));
    }
    // true while the pointer is moving toward the panel (side 'right': a rail or a tab column with its panel beside it; 'below': tabs
    // over a card); a pointer still for 70 ms is resting, not moving
    function aimToward(pane, side) {
      var r = pane && pane.getBoundingClientRect(), p = AIM.pts;
      if (!r || !r.width || p.length < 2 || Date.now() - AIM.at > 70) return false;
      var cur = p[p.length - 1], prev = p[0], k = 24, a, b;
      if (cur.x === prev.x && cur.y === prev.y) return false;
      if (side === 'below') { if (cur.y >= r.top) return false; a = { x: r.left - k, y: r.top + k }; b = { x: r.right + k, y: r.top + k }; }
      else { if (cur.x >= r.left) return false; a = { x: r.left + k, y: r.top - k }; b = { x: r.left + k, y: r.bottom + k }; }
      return inTri(cur, prev, a, b);
    }
    // how far the pointer still is from the panel's near edge
    function aimGap(pane, side) {
      var r = pane && pane.getBoundingClientRect(), c = AIM.pts[AIM.pts.length - 1];
      return r && c ? (side === 'below' ? r.top - c.y : r.left - c.x) : 0;
    }
    // a pointer resting on an item shows it; aim = { pane: function () { return element; }, side: 'right' | 'below' }, or nothing for the
    // plain 70 ms rest (as before). Returns cancel(), for a click or key that acts first.
    function hoverIntent(host, sel, onHover, aim) {
      var t = null, want = null, gap = 0, since = 0;
      if (aim) aimTrack();
      function aiming() {
        if (!aim || !aimToward(aim.pane(), aim.side)) return false;
        var g = aimGap(aim.pane(), aim.side), now = Date.now();
        if (g < gap - 1) { gap = g; since = now; }
        return now - since < 250;
      }
      function tick() { t = null; if (!want) return; if (aiming()) { t = setTimeout(tick, 70); return; } var b = want; want = null; onHover(b); }
      host.addEventListener('mouseover', function (e) {
        var b = e.target.closest(sel); if (!b || !host.contains(b)) return;
        if (b !== want) { want = b; gap = aim ? aimGap(aim.pane(), aim.side) : 0; since = Date.now(); }
        clearTimeout(t); t = setTimeout(tick, 70);
      });
      host.addEventListener('mouseleave', function () { clearTimeout(t); t = null; want = null; });
      return function () { clearTimeout(t); t = null; want = null; };
    }
    // Clean Bench round 2026-10-21: the new header menus (assets/imods-cb.js) use the same hover intent
    imods.hoverIntent = hoverIntent; imods.aimToward = aimToward;
    // FIX-10 (menus/base.js rail()): a list of choices; a pointer resting 70 ms, a click, focus or the arrow keys pick one
    function rail(host, onPick) {
      var t = null, sel = 'button[data-v]';
      host.addEventListener('mouseover', function (e) { var b = e.target.closest(sel); if (!b || !host.contains(b)) return; clearTimeout(t); t = setTimeout(function () { onPick(b, false); }, 70); });
      host.addEventListener('mouseleave', function () { clearTimeout(t); });
      host.addEventListener('click', function (e) { var b = e.target.closest(sel); if (b && host.contains(b)) { clearTimeout(t); onPick(b, true); } });
      host.addEventListener('focusin', function (e) { var b = e.target.closest(sel); if (b && host.contains(b)) onPick(b, false); });
      host.addEventListener('keydown', function (e) {
        var k = e.key; if (['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(k) < 0) return;
        var bs = imods.$$(sel, host), i = bs.indexOf(document.activeElement); if (i < 0) return;
        e.preventDefault();
        (bs[k === 'Home' ? 0 : k === 'End' ? bs.length - 1 : Math.max(0, Math.min(bs.length - 1, i + (/Down|Right/.test(k) ? 1 : -1)))]).focus();
      });
    }
    function press(host, v) { imods.$$('button[data-v]', host).forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-v') === v ? 'true' : 'false'); }); }
    // the part names, plurals and part-type links come from the server links (snippets/imods-part-table.liquid)
    function partMeta(d) {
      if (d.__imMeta) return d.__imMeta;
      var meta = { order: [] };
      imods.$$('[data-im-part-link]', d).forEach(function (a) {
        var p = a.getAttribute('data-im-part-link'); if (meta[p]) return;
        meta.order.push(p); meta[p] = { href: a.getAttribute('href'), plural: a.getAttribute('data-im-plural') || p, label: a.textContent.trim() };
      });
      return (d.__imMeta = meta);
    }
    function housingNote(part, f) { return housing(part, f.k) ? '<em class="im-m-note">Housing</em>' : ''; }

    // ---- iPod Parts, computer (owner pick: concept 1, two panes): the part list at the left; beside it the eight iPods with
    // the Part and Installed prices; below, the parts search, Identify your iPod, the free repair quote and All iPod parts
    function partsPane(part, meta) {
      var m = meta[part];
      var pill = function (f, inst) {
        var x = priceFor(part, f, inst), lab = inst ? 'Installed' : 'Part';
        if (!x) return '<span class="im-m1-price is-none" aria-hidden="true"></span>';
        return '<a class="im-m1-price" data-im-route="' + (inst ? 'installed' : 'part') + '" href="' + esc(x.href) + '" aria-label="' + esc(SHORT[f.k] + ' ' + (housing(part, f.k) ? 'housing' : m.label.toLowerCase()) + ', ' + (inst ? 'installed' : 'part only') + ', ' + (x.from ? 'from ' : '') + x.txt) + '"><span>' + lab + '</span> ' + (x.from ? '<small>from</small> ' : '') + '<b>' + x.txt + '</b></a>';
      };
      return '<div class="im-m1-head"><span class="im-m1-h">' + esc(m.label) + ' <span class="im-m-muted">· which iPod? · representative photos</span></span><a class="im-m-link" href="' + esc(m.href) + '">All ' + esc(m.plural) + ' ›</a></div>' +
        '<ul class="im-m1-mods" role="list"><li class="im-m1-colhead" aria-hidden="true"><span></span><span>Part</span><span>Installed</span></li><li class="im-m1-colhead" aria-hidden="true"><span></span><span>Part</span><span>Installed</span></li>' +
        fams().map(function (f) {
          var any = priceFor(part, f, false) || priceFor(part, f, true);
          return '<li class="im-m1-mod' + (any ? '' : ' is-off') + '" data-k="' + f.k + '"><a class="im-m1-mod__name" href="' + esc(rowHref(part, f, any)) + '" aria-label="' + esc(rowLabel(part, f, any, m)) + '">' + pic(f, 96) +
            '<span>' + esc(TILE[f.k]) + housingNote(part, f) + '<small>' + esc(f.no) + ' · ' + esc(f.yr) + (housing(part, f.k) ? ' · Housing' : '') + '<span data-im-tagslot></span></small></span></a>' +
            ppCell(part, f.k) + '<span class="im-m1-mod__prices">' + (any ? pill(f, false) + pill(f, true) : '<span class="im-m1-none">Not offered</span>') + '</span></li>';
        }).join('') + '</ul>';
    }
    // menus round 2 (owner I-17, R2-5 "use", Q-R2-5 "computers only"; mock menus_r2/src/parts.js): each iPod row of the open part shows a
    // small photo of THAT iPod's part beside its Part / Installed prices. Real photos only, from the generated map assets/imods-part-photos.json
    // (site_ideas_20261008/menus_r2/tools/gen_part_photos.py: the part itself by the COMP_RX rule, the standard part before the 2000mAh /
    // custom one; regenerate after a product photo change); no real photo = the part's line icon, never a placeholder. Loaded on intent.
    var PPMAP = null, ppP = null;
    function ppLoad(d) {
      var u = d.getAttribute('data-im-pp'); if (!u) return Promise.resolve(null);
      if (!ppP) ppP = fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) { PPMAP = j.pp || {}; return PPMAP; }).catch(function () { ppP = null; return null; });
      return ppP;
    }
    function ppCell(part, k) {
      if (!PPMAP) return '';
      var u = PPMAP[part + '|' + k];
      if (u) return '<span class="im-pp"><img src="' + esc(u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=160') + '" alt="" width="64" height="48" loading="lazy" decoding="async"></span>';
      // sitting 2 blind check (3 of 3 judges, 2026-10-26): an icon tile in the photo column reads as a "no photo" placeholder (rubric
      // G-05); a row without a real part photo keeps the column empty so its prices still line up
      return '<span class="im-pp im-pp--none" aria-hidden="true"></span>';
    }
    function deskParts(d) {
      var panel = d.querySelector('.im-panel'); if (!panel) return;
      var meta = partMeta(d); if (!meta.order.length) return;
      var srch = imods.$('[data-im-psearch]', d), part = meta[MEM.part] ? MEM.part : meta.order[0];
      var html = '<div class="page-width im-m im-m1"><ul class="im-m1-rail" role="list" aria-label="Parts">' + meta.order.map(function (p) {
        return '<li><button type="button" class="im-m1-rail__b" data-v="' + esc(p) + '" aria-pressed="' + (p === part) + '">' + mico(ICON[p]) + '<span>' + esc(meta[p].label) + '</span></button></li>';
      }).join('') + '</ul><div class="im-m1-pane">' + partsPane(part, meta) + '</div>' +
        '<div class="im-m-foot im-m1-foot"><a class="im-m-link" href="/pages/identify-your-ipod">Identify your iPod</a><a class="im-m-link" href="' + DIAG + '">Not sure what\'s wrong? Free repair quote</a><a class="im-m-link" href="/collections/ipod-replacement-parts">All iPod parts ›</a></div></div>';
      panel.innerHTML = html;
      var root = panel.firstChild, pane = root.querySelector('.im-m1-pane'), foot = root.querySelector('.im-m-foot');
      if (srch) { foot.insertBefore(srch, foot.firstChild); var inp = imods.$('input[type="search"]', srch); if (inp) inp.placeholder = 'Part number or model, e.g. 616-0232'; }
      mark(pane);
      var railEl = root.querySelector('.im-m1-rail');
      // S10 (owner 2026-10-07, "Yes, same fix" as Shop iPods): resting on a part, or focus, still shows its iPods; a click or Enter opens
      // that part's page for every iPod (meta[p].href = the link the part has with JavaScript off). Touch: the first touch on a part that
      // isn't showing shows it, a second touch opens it (a tap focuses before its click, so what was showing is read at pointerdown).
      var touch = false, shown = part;
      railEl.addEventListener('pointerdown', function (e) { touch = e.pointerType === 'touch'; shown = part; });
      railEl.addEventListener('keydown', function () { touch = false; });
      rail(railEl, function (b, isClick) {
        var p = b.getAttribute('data-v');
        if (isClick && !(touch && p !== shown) && meta[p] && meta[p].href) { location.href = meta[p].href; return; }
        if (p === part) return;
        part = MEM.part = p; press(railEl, p); pane.innerHTML = partsPane(p, meta); mark(pane); refit();
      });
      ppLoad(d).then(function (m) { if (m) { pane.innerHTML = partsPane(part, meta); mark(pane); refit(); } });
    }
    // ---- iPod Parts, phone (concept 1): step 1 = the parts search and the part list; step 2 = that part's iPods table
    // (iPod | Part | Installed), with a back row
    function phoneFlow(d, back, list, detail, onPick) {
      var body = d.querySelector('.im-drawer__subbody'); if (!body) return;
      var srch = imods.$('[data-im-psearch]', body);
      body.innerHTML = '<div class="im-mp" data-im-step="1">' + list() + '</div><div class="im-mp" data-im-step="2" hidden></div>';
      var s1 = body.firstChild, s2 = body.lastChild, last = null;
      var slot = s1.querySelector('[data-im-sslot]'); if (slot) { if (srch) slot.parentNode.replaceChild(srch, slot); else slot.remove(); }
      function top() { var dp = d.closest('.im-drawer__panel'); if (dp) dp.scrollTop = 0; }
      function show(v) {
        if (v == null) {
          s2.hidden = true; s2.innerHTML = ''; s1.hidden = false; top();
          var b = last && s1.querySelector('[data-pick="' + last + '"]'); if (b) b.focus({ preventScroll: true });
          return;
        }
        last = v; s2.innerHTML = '<button type="button" class="im-mp-back" data-back>‹ ' + back + '</button>' + detail(v);
        s1.hidden = true; s2.hidden = false; mark(s2); top();
        s2.querySelector('[data-back]').focus({ preventScroll: true });
      }
      body.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pick]'); if (b && body.contains(b)) { var v = b.getAttribute('data-pick'); if (onPick) onPick(v); show(v); return; }
        if (e.target.closest('[data-back]')) show(null);
      });
      mark(s1);
    }
    function phoneParts(d) {
      var meta = partMeta(d); if (!meta.order.length) return;
      phoneFlow(d, 'All parts', function () {
        return '<span data-im-sslot></span><ul class="im-mp-list" role="list">' + meta.order.map(function (p) {
          return '<li><button type="button" class="im-mp-row" data-pick="' + esc(p) + '">' + mico(ICON[p]) + '<span>' + esc(meta[p].label) + '</span><span class="im-mp-go" aria-hidden="true">›</span></button></li>';
        }).join('') + '</ul><p class="im-mp-links"><a class="im-mp-more" href="/collections/ipod-replacement-parts">All iPod parts</a><a class="im-mp-more" href="/pages/identify-your-ipod">Identify your iPod</a></p>';
      }, function (part) {
        var m = meta[part] || meta[meta.order[0]];
        var cell = function (f, inst) { var x = priceFor(part, f, inst); return x ? '<a class="im-mp-pr" data-im-route="' + (inst ? 'installed' : 'part') + '" href="' + esc(x.href) + '" aria-label="' + esc(SHORT[f.k] + ', ' + (inst ? 'installed' : 'part only') + ', ' + (x.from ? 'from ' : '') + x.txt) + '">' + (x.from ? '<small>from</small> ' : '') + x.txt + '</a>' : '<span class="im-mp-na">—</span>'; };
        return '<p class="im-mp-h im-mp-h--row"><span>' + esc(m.label) + ': which iPod?</span><a class="im-mp-more" href="' + esc(m.href) + '">All ' + esc(m.plural) + '</a></p>' + REP +
          '<div class="im-mp-tab" role="table" aria-label="' + esc(m.label + ' prices') + '"><div class="im-mp-tr im-mp-th" role="row"><span role="columnheader">iPod</span><span role="columnheader">Part</span><span role="columnheader">Installed</span></div>' +
          fams().map(function (f) {
            var any = priceFor(part, f, false) || priceFor(part, f, true);
            return '<div class="im-mp-tr" role="row" data-k="' + f.k + '"><span role="cell"><a class="im-mp-name" href="' + esc(rowHref(part, f, any)) + '">' + pic(f, 96) + '<span>' + esc(TILE[f.k]) + (housing(part, f.k) ? '<small>Housing</small>' : '') + '<span data-im-tagslot></span></span></a></span><span role="cell">' + cell(f, false) + '</span><span role="cell">' + cell(f, true) + '</span></div>';
          }).join('') + '</div>';
      }, function (p) { MEM.part = p; });
    }

    // FIX-10 set 6 (BUILD_PLAN 3d): the other names buyers use for each iPod (search keys only, never shown). "color display"
    // is a phrase for the Photo (rewritten in run); 6th and 7th Gen share A1238, so the model number finds both, labelled.
    var ALIAS = { '3G': 'third 3rd', '4G': 'fourth 4th mono monochrome grayscale greyscale', Photo: 'fourth 4th photo color colour', '5G': 'fifth 5th video 5.5g 5.5 enhanced classic', '6G': 'sixth 6th classic', '7G': 'seventh 7th classic', Mini1: 'first 1st 1g mini', Mini2: 'second 2nd 2g mini' };
    function searchIndex() {
      if (D.__idx) return D.__idx;
      var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }, seen = {}, idx = [];
      // three key tiers, ranked: own (the item's title, handle, part number), alias (ALIAS), fam (model number and names)
      var fam = function (f) { return ' ' + f.no.toLowerCase() + ' ' + norm(f.no) + ' ' + f.sl.toLowerCase() + ' ' + f.ss.toLowerCase() + ' ' + SHORT[f.k].toLowerCase(); };
      D.parts.forEach(function (part) { fams().forEach(function (f) { (D.pp[part + '|' + f.k] || []).forEach(function (q) {
        if (seen[q.handle]) return; seen[q.handle] = 1;
        idx.push({ kind: 'part', part: part, f: f, q: q, ids: norm(q.pn) + ' ' + norm(f.no), own: ' ' + norm(q.pn) + ' ' + q.title.toLowerCase() + ' ' + q.handle.replace(/-/g, ' '), alias: ' ' + ALIAS[f.k], fam: fam(f) });
      }); }); });
      fams().forEach(function (f) { (D.units[f.k] || []).forEach(function (x) {
        var prs = x.variants.filter(function (v) { return v.avail; }).map(cOf); if (!prs.length) return;
        idx.push({ kind: 'unit', f: f, u: x, low: Math.min.apply(null, prs), ids: norm(f.no), own: ' ' + x.title.toLowerCase() + ' ' + x.handle.replace(/-/g, ' ') + ' refurbished ipod for sale', alias: ' ' + ALIAS[f.k], fam: fam(f) });
      }); });
      idx.norm = norm; D.__idx = idx; return idx;
    }
    // a query word matches at the start of a word ("5g" is not inside "15gb" or "6.5g"); a model word (4g, 5.5g) must also
    // end there ("4g" is not "4gb", the 4GB Mini)
    function has(key, w) {
      var i = -1, whole = /^\d+(\.\d+)?g$/.test(w);
      while ((i = key.indexOf(w, i + 1)) >= 0) {
        if (i > 0 && /[a-z0-9.]/.test(key.charAt(i - 1))) continue;
        if (whole && /[a-z0-9]/.test(key.charAt(i + w.length))) continue;
        return true;
      }
      return false;
    }
    // every word must match somewhere; the item's own words rank first, then the names in ALIAS, then the model's names
    function score(x, words, qn) {
      var s = 0;
      for (var i = 0; i < words.length; i++) {
        var w = words[i], t = (has(x.own, w) ? 3 : 0) + (has(x.alias, w) ? 2 : 0) + (has(x.fam, w) ? 1 : 0);
        if (!t) { s = 0; break; }
        s += t;
      }
      // a part or model number typed whole or in part ("616-0232", "0232", "A1136")
      if (/\d/.test(qn) && qn.length >= 4 && x.ids.indexOf(qn) >= 0) s += 3;
      return s;
    }
    function initSearch(host) {
      var form = imods.$('[data-im-psearch]', host); if (!form || form.__im) return; form.__im = 1;
      var inp = imods.$('input[type="search"]', form), out = imods.$('[data-im-psearch-results]', form), idx = searchIndex();
      inp.setAttribute('aria-controls', out.id || (out.id = inp.id + '-results'));
      function run() {
        var q = inp.value.trim().toLowerCase(), qn = idx.norm(q);
        if (q.length < 2) { out.innerHTML = ''; return; }
        var words = q.replace(/\bcolou?r\s+display\b/g, 'photo').split(/\s+/);
        var hits = idx.map(function (x) { return { x: x, s: score(x, words, qn) }; }).filter(function (h) { return h.s > 0; });
        hits.sort(function (a, b) { return (b.s - a.s) || ((a.x.kind === 'unit') - (b.x.kind === 'unit')); });
        hits = hits.map(function (h) { return h.x; });
        // FIX-7: the desktop Parts panel is shorter; it lists the top 5 and a row to the full results, so nothing scrolls
        var max = host.closest && host.closest('[data-im-nav]') ? 5 : 8, more = hits.length > max;
        hits = hits.slice(0, max);
        if (!hits.length) { out.innerHTML = '<p class="im-psearch__none">Nothing matches “' + esc(inp.value.trim()) + '”. Try a part number (616-0232), a model number (A1136) or a word like “battery”.</p>'; return; }
        out.innerHTML = '<p class="im-vh">' + hits.length + ' results</p><ul role="list">' + hits.map(function (h) {
          if (h.kind === 'unit') return '<li><a class="im-sres" href="/products/' + esc(h.u.handle) + '"><span class="im-iwell">' + icon('ipod') + '</span><span><b>' + esc(name(h.u.title.replace(/^Refurbished\s+/i, ''))) + '</b><small>' + esc(SHORT[h.f.k]) + ' · Refurbished iPod · from ' + money(h.low) + '</small></span></a></li>';
          return '<li><a class="im-sres" href="/products/' + esc(h.q.url_handle || h.q.handle) + '"><span class="im-iwell">' + icon(ICON[h.part]) + '</span><span><b>' + esc(name(h.q.title.replace(/^.*?—\s*/, ''))) + '</b><small>' + esc(SHORT[h.f.k]) + ' · ' + esc(h.part) + (h.q.pn ? ' · PN ' + esc(h.q.pn) : '') + '</small></span></a></li>';
        }).join('') + (more ? '<li><a class="im-sres im-sres--all" href="/search?type=product&q=' + encodeURIComponent(inp.value.trim()) + '"><span><b>See all results for “' + esc(inp.value.trim()) + '”</b></span></a></li>' : '') + '</ul>';
      }
      inp.addEventListener('input', run);
      inp.addEventListener('keydown', function (e) {
        var rs = imods.$$('a.im-sres', out);
        if (e.key === 'ArrowDown' && rs.length) { e.preventDefault(); rs[0].focus(); }
        else if (e.key === 'Escape' && inp.value) { e.preventDefault(); inp.value = ''; out.innerHTML = ''; }
      });
      out.addEventListener('keydown', function (e) {
        var rs = imods.$$('a.im-sres', out), i = rs.indexOf(document.activeElement);
        if (i < 0) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); (rs[i + 1] || rs[i]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (i ? rs[i - 1] : inp).focus(); }
        else if (e.key === 'Escape') { e.preventDefault(); inp.focus(); }
      });
      if (inp.value.trim().length >= 2) run();
    }

    // FIX-9 (owner, "Plain unit, $355.95"): the "from" price is the unit as it came from Apple: an original-drive storage
    // choice (never "flash" or "(included)"), not a new case ("Brand New" condition), not the 2000mAh battery; the same
    // rule as the Build your iPod cards (sections/imods-builder.liquid). A model with no such unit shows no "from".
    // FIX-10 (item c): a flash-built listing is known by its name (handle or title "flash"): its sizes read "256GB"
    function flashListing(x) { return /flash/i.test((x.title || '') + ' ' + (x.handle || '')); }
    function plainUnit(v) {
      var so = v.so || {}, ks = Object.keys(so), pick = function (rx) { return ks.filter(function (n) { return rx.test(n); })[0]; };
      var sk = pick(/storage|capacity/i), ck = pick(/condition/i), bk = pick(/^battery$/i);
      if (!sk || /flash|included/i.test(so[sk] || '')) return false;
      if (ck && /brand new|new case/i.test(so[ck] || '')) return false;
      if (bk && /2000/.test(so[bk] || '')) return false;
      return true;
    }
    function famFromV(k) {
      var best = null;
      (D.units[k] || []).forEach(function (x) { if (flashListing(x)) return; x.variants.forEach(function (v) { if (v.avail && plainUnit(v)) { var c = cOf(v); if (!best || c < best.c) best = { c: c, x: x, v: v }; } }); });
      return best;
    }
    function famFrom(k) { var b = famFromV(k); return b ? b.c : null; }
    // The first iPod shown: the page's own model, then "Your iPod", then the iPod Video 5th Gen.
    function first() { return (MEM.fam && SHORT[MEM.fam]) ? MEM.fam : (yours() || '5G'); }
    function famOf(k) { return fams().filter(function (x) { return x.k === k; })[0] || fams()[0]; }
    function shopFams() { return fams().filter(function (f) { return (D.units[f.k] || []).length; }); }
    // ---- phone: step 1 = the iPod photo tiles; step 2 = that iPod's screen, with a back row
    function tiles(list, withFrom) {
      return '<ul class="im-mp-grid" role="list">' + list.map(function (f) {
        var from = withFrom ? famFrom(f.k) : null;
        return '<li><button type="button" class="im-mp-tile" data-pick="' + f.k + '" data-k="' + f.k + '">' + pic(f, 120) + '<span class="im-mp-tile__t">' + esc(TILE[f.k]) + '<small>' + (from != null ? 'from ' + money(from) : esc(f.no)) + '</small><span data-im-tagslot></span></span></button></li>';
      }).join('') + '</ul>';
    }

    // ---- menus round 2 (owner marks 2026-10-16, site_ideas_20261008/OWNER_ANSWERS_SITE_IDEAS.md §27 + §29; built 2026-10-17 from the
    // approved mocks menus_r2/src/shop.js + flash.js + tabs.css): Shop iPods and Flash Mods as the iPods in a row of tabs joined to ONE
    // card. Replaces FIX-10's photo strip + link chips (deskStrip/shopDetail; prestate sym_build1/prestate/menusr2/pre/assets/imods-core.js).
    function tbPic(url, w, cls) {
      if (!url) return '';
      var u = String(url).replace(/([?&])width=\d+/, '$1width=' + w);
      return '<img class="' + cls + '" src="' + esc(u) + '" alt="" width="48" height="48" loading="lazy" decoding="async">';
    }
    // a choice redraws the card; the focus stays on the same choice (keyboard users keep their place)
    function keepFocus(host, fn) {
      var a = document.activeElement, sel = null;
      if (a && host.contains(a)) ['data-cap', 'data-bat', 'data-color', 'data-sto', 'data-music'].forEach(function (n) { if (!sel && a.hasAttribute(n)) sel = '[' + n + (a.getAttribute(n) ? '="' + String(a.getAttribute(n)).replace(/"/g, '\\"') + '"' : '') + ']'; });
      fn();
      if (sel) { var b = host.querySelector(sel); if (b) b.focus({ preventScroll: true }); }
    }
    // S10 (owner 2026-10-07, "Click opens that iPod's for-sale page"; kept for both tab menus): a pointer resting on a tab, or focus,
    // shows that iPod in the card; a click or Enter opens its page (href(k): Shop = its for-sale page, Flash = its flash page). Touch
    // screens have no hover: the first touch on a tab that isn't showing shows it, the next opens it (what was showing is read at
    // pointerdown, since a tap focuses the tab before its click). The arrow keys, Home and End move between the tabs.
    function tabsRule(tabs, cur, show, href) {
      var t = null, touch = false, shown = null, sel = '.im-tb__tab[data-k]';
      tabs.addEventListener('mouseover', function (e) { var b = e.target.closest(sel); if (!b || !tabs.contains(b)) return; clearTimeout(t);
        t = setTimeout(function () { var k = b.getAttribute('data-k'); if (k !== cur()) show(k); }, 70); });
      tabs.addEventListener('mouseleave', function () { clearTimeout(t); });
      tabs.addEventListener('focusin', function (e) { var b = e.target.closest(sel); if (b && tabs.contains(b) && b.getAttribute('data-k') !== cur()) show(b.getAttribute('data-k')); });
      tabs.addEventListener('pointerdown', function (e) { var b = e.target.closest(sel); touch = !!b && e.pointerType === 'touch'; shown = cur(); });
      tabs.addEventListener('keydown', function (e) {
        var k = e.key; if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(k) < 0) { touch = false; return; }
        var bs = imods.$$(sel, tabs), i = bs.indexOf(document.activeElement); if (i < 0) return;
        e.preventDefault();
        bs[k === 'Home' ? 0 : k === 'End' ? bs.length - 1 : Math.max(0, Math.min(bs.length - 1, i + (k === 'ArrowRight' ? 1 : -1)))].focus();
      });
      tabs.addEventListener('click', function (e) {
        var b = e.target.closest(sel); if (!b || !tabs.contains(b)) return;
        var k = b.getAttribute('data-k'); e.stopPropagation(); clearTimeout(t);
        if (touch && k !== shown) { show(k); return; }
        location.href = href(k);
      }, true);
    }
    function tbSelect(tabs, k) { imods.$$('.im-tb__tab[data-k]', tabs).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-k') === k ? 'true' : 'false'); }); }
    function chip(kind, val, inner, on, off) {
      return '<button type="button" class="im-tb-chip" data-' + kind + '="' + esc(val) + '" aria-pressed="' + on + '"' + (off ? ' aria-disabled="true"' : '') + '>' + inner + '</button>';
    }
    function tbRow(lab, inner) { return '<div class="im-tb-row"><span class="im-tb-row__lab">' + lab + '</span>' + inner + '</div>'; }

    // ---- Shop iPods (owner I-19 "more together" + I-13 "select all details of the iPod and then the button would appear"; R2-2 "use",
    // R2-2b "keep" = WITH the "Choose ... to see your iPod and its price" box). Colour, storage and battery are choices; once all are
    // chosen the button appears with that exact iPod's price and opens its page with those choices made (?variant=) in the one-screen
    // "Your iPod" mode (&yours=1, R2-3, only from this button: Q-R2-3). The unit and price = Build your iPod's own rule (imods.units:
    // lowest-priced eligible unit of that colour; 30GB 5th Gen flash up to 256GB; 2000mAh with flash only; no U2 on the 4th Gen / Photo).
    function shPicker() {
      var U = imods.units, ST = { k: null, color: null, sto: null, bat: null };
      function c() { return { D: D, R: D.rules || {}, fam: ST.k, songs: 0 }; }
      function colors() { return U.colors(c()); }
      function opts(color, bk) { return color ? U.storageOpts(c(), color, false, bk || 'std') : []; }
      function pick(k) {
        ST.k = k; ST.sto = null; ST.pend = false; var cs = colors(); ST.color = cs.length === 1 ? cs[0] : null; ST.bat = U.batKinds(c()).length === 1 ? 'std' : null;
        // W6-a (owner section 38 "Let's have the base choices pre-selected for each model and reader can adjust as needed", marked use
        // 2026-10-18): the iPod opens with its base choices made = the unit behind its "from" price (famFromV: its own hard drive, the new
        // battery, the lowest-priced color), so the price and the button show at once; every chip still changes it
        var best = null;
        cs.forEach(function (col) { opts(col, 'std').forEach(function (o) { if (o.flash) return; var p = cOf(o.v); if (!best || p < best.p) best = { col: col, key: o.key, p: p }; }); });
        if (best) { ST.color = best.col; ST.sto = best.key; ST.bat = 'std'; }
      }
      function chosen() {
        if (!ST.color || !ST.sto || !ST.bat) return null;
        var o = opts(ST.color, ST.bat).filter(function (x) { return x.key === ST.sto; })[0]; if (!o) return null;
        var v = U.find(o.unit, U.condVal(o.unit, false), o.v.so[U.keysOf(o.unit).sto], U.batVal(o.unit, ST.bat));
        return v && U.offered(c(), o.unit, v) ? { unit: o.unit, v: v, o: o } : null;
      }
      function rows() {
        var cs = colors(), out = '';
        out += tbRow('Color', '<div class="im-tb-chips">' + cs.map(function (col) { return chip('color', col, '<b><i style="background:' + (SW[col] || '#ddd') + '"></i>' + esc(col) + '</b>', col === ST.color); }).join('') + '</div>');
        var os = opts(ST.color || cs[0], 'std');
        var hdd = os.filter(function (o) { return !o.flash; }), fl = os.filter(function (o) { return o.flash; });
        var sc = function (o) { return chip('sto', o.key, '<b>' + o.label + '</b><small>' + (ST.color ? money(cOf(o.v)) : (o.flash ? 'flash' : 'hard drive')) + '</small>', o.key === ST.sto); };
        out += tbRow('Storage', '<div>' + (hdd.length ? '<div class="im-tb-subrow"><span class="im-tb-sub">Hard drive</span><div class="im-tb-chips">' + hdd.map(sc).join('') + '</div></div>' : '') +
          (fl.length ? '<div class="im-tb-subrow"><span class="im-tb-sub">Flash</span><div class="im-tb-chips">' + fl.map(sc).join('') + '</div></div>' : '') + '</div>');
        var cur = ST.sto && ST.color ? opts(ST.color, 'std').filter(function (o) { return o.key === ST.sto; })[0] : null;
        out += tbRow('Battery', '<div class="im-tb-chips">' + U.batKinds(c()).map(function (kind) {
          if (kind === 'std') return chip('bat', 'std', '<b>New battery</b><small>included</small>', ST.bat === 'std');
          var lab = kind === '2000' ? '2000mAh extended-life' : '1200mAh extended-life', small = '', off = false;
          if (kind === '2000' && cur && !cur.flash) { off = true; small = 'with flash only'; }
          else if (cur) { var x = opts(ST.color, kind).filter(function (o) { return o.key === ST.sto; })[0]; small = x ? '+' + money(cOf(x.v) - cOf(cur.v)) : ''; }
          else small = kind === '2000' ? 'with flash' : '';
          return chip('bat', kind, '<b>' + lab + '</b>' + (small ? '<small>' + small + '</small>' : ''), ST.bat === kind, off);
        }).join('') + '</div>');
        return out;
      }
      function buy() {
        var r = chosen(), need = [];
        if (!ST.color) need.push('color'); if (!ST.sto) need.push('storage'); if (!ST.bat) need.push('battery');
        if (!r) {
          var list = need.length > 1 ? need.slice(0, -1).join(', ') + ' and ' + need[need.length - 1] : (need[0] || 'your choices');
          return '<div class="im-tb-buy im-tb-buy--wait"><p class="im-tb-hint">Choose ' + esc(list) + ' to see your iPod and its price.</p></div>';
        }
        var o = r.o, what = o.label + (o.flash ? ' flash' : ' hard drive') + ' · ' + (ST.bat === 'std' ? 'new battery' : (ST.bat + 'mAh battery')) + ' · original case';
        // the new case is chosen on Build your iPod (its colours); a model with no new case gets the plain builder link
        var alt = U.hasNewCase(c()) ? 'Or build it with a new case ›' : 'Or see it on Build your iPod ›';
        return '<div class="im-tb-buy"><p class="im-tb-price">' + money(cOf(r.v)) + '</p><p class="im-tb-price__sub">' + esc(ST.color + ' · ' + what) + '</p>' +
          '<a class="im-btn im-tb-go" href="/products/' + esc(r.unit.handle) + '?variant=' + esc(r.v.id) + '&amp;yours=1">See this iPod</a>' +
          '<a class="im-tb-alt" href="' + esc(atBuild(BUILD + ST.k)) + '">' + alt + '</a></div>';
      }
      function idcol(phone) {
        var f = famOf(ST.k);
        // owner 2026-10-23: family pictures for models and menus, the individual picture where one iPod helps: the chosen colour's
        // picture (imods.fronts); no colour yet, or a colour with no picture of its own = the model's family picture (today's)
        var pic = (imods.fronts && ST.color && imods.fronts(ST.k, ST.color)) || f.img;
        if (phone) return '<div class="im-tb-id">' + tbPic(pic, 240, 'im-tb-id__pic') + '<div><p class="im-tb-id__name">' + esc(SHORT[ST.k]) + '</p><p class="im-tb-id__meta">' + esc(f.no + ' · ' + f.yr) + '</p></div></div>';
        return '<div class="im-tb-id">' + tbPic(pic, 240, 'im-tb-id__pic') + (f.refurb ? '<a class="im-tb-id__name" href="' + esc(f.refurb) + '">' + esc(SHORT[ST.k]) + '</a>' : '<p class="im-tb-id__name">' + esc(SHORT[ST.k]) + '</p>') +
          '<p class="im-tb-id__meta">' + esc(f.no + ' · ' + f.yr) + '</p></div>';
      }
      // 2026-10-24 (owner): "Every <model> for sale" and "Not sure which model? Identify your iPod" sit under the model list
      function more() {
        var f = famOf(ST.k);
        return (f.refurb ? '<a class="im-tb-id__link" href="' + esc(f.refurb) + '">Every ' + esc(TILE[ST.k]) + ' for sale ›</a>' : '') +
          '<a class="im-tb-id__link im-tb-id__link--q" href="/pages/identify-your-ipod"><span>Not sure which model?</span> Identify your iPod ›</a>';
      }
      function card(phone) { return phone ? idcol(true) + '<div class="im-tb-opts">' + rows() + '</div>' + buy() : '<div class="im-sh__body">' + idcol(false) + '<div class="im-tb-opts">' + rows() + '</div>' + buy() + '</div>'; }
      function wire(root, redraw) {
        root.addEventListener('click', function (e) {
          var t = e.target.closest('[data-color],[data-sto],[data-bat]'); if (!t || !root.contains(t)) return;
          if (t.getAttribute('aria-disabled') === 'true') return;
          if (t.hasAttribute('data-color')) { ST.color = t.getAttribute('data-color'); if (ST.sto && !opts(ST.color, 'std').some(function (o) { return o.key === ST.sto; })) ST.sto = null; }
          else if (t.hasAttribute('data-sto')) {
            var was = ST.sto ? opts(ST.color, 'std').filter(function (x) { return x.key === ST.sto; })[0] : null;
            ST.sto = t.getAttribute('data-sto'); var o = opts(ST.color, 'std').filter(function (x) { return x.key === ST.sto; })[0];
            if (ST.bat === '2000' && o && !o.flash) ST.bat = null;
            // owner 2026-10-26 (the refurbished pages' rule, review list B2): hard drive -> flash clears the battery where this storage takes
            // the 2000mAh (5th-7th Gen), so the buyer sees it and picks one; the price and the button wait for that pick. Back to a hard
            // drive before a pick: the standard battery again (the 2000mAh is flash only)
            else if (o && o.flash && !(was && was.flash) && ST.bat !== '2000' && opts(ST.color, '2000').some(function (x) { return x.key === ST.sto && U.is2000(x.v.so[U.keysOf(x.unit).bat]); })) { ST.bat = null; ST.pend = true; }
            else if (ST.pend && o && !o.flash) { ST.bat = 'std'; ST.pend = false; }
          }
          else { ST.bat = t.getAttribute('data-bat'); ST.pend = false; }
          redraw();
        });
      }
      return { ST: ST, pick: pick, card: card, more: more, wire: wire, chosen: chosen, colors: colors, opts: opts, batKinds: function () { return U.batKinds(c()); } };
    }
    function shTabs(list, sel) {
      return '<ul class="im-tb__tabs" role="tablist" aria-label="Choose your iPod">' + list.map(function (f) {
        var fr = famFrom(f.k);
        return '<li role="presentation"><button type="button" role="tab" class="im-tb__tab" data-k="' + f.k + '" aria-selected="' + (f.k === sel) + '">' + tbPic(f.img, 96, 'im-tb__pic') + '<b>' + esc(TILE[f.k]) + '</b><small>' + (fr != null ? 'from ' + money(fr) : esc(f.no)) + '</small><span data-im-tagslot></span></button></li>';
      }).join('') + '</ul>';
    }
    function deskShop(d) {
      var panel = d.querySelector('.im-panel'); if (!panel) return;
      var list = shopFams(); if (!list.length) return;
      var P = shPicker(), sel = first(); if (!list.some(function (f) { return f.k === sel; })) sel = list[0].k;
      P.pick(sel);
      // owner 2026-10-17 ~01:3x (build session): "Remove the title so that it's one line and appears to belong to the menu": no "Build your
      // iPod" heading; the line above the tabs = the lead + the two links, on one line
      panel.innerHTML = '<div class="page-width"><div class="im-tb im-sh"><div class="im-tb__head"><p class="im-tb__lead">Refurbished by us with a 1-year limited warranty. Representative photos.</p>' +
        '<a class="im-tb__all" href="/collections/ipods-for-sale#browse">Browse every refurbished iPod ›</a><a class="im-tb__all im-tb__all--2" href="/collections/ipod-flash-mods#built">Flash-modded iPods for sale ›</a></div>' +
        shTabs(list, sel) + '<div class="im-tb__card" role="tabpanel"></div><div class="im-sh__more" data-im-shmore></div></div></div>';
      var root = panel.querySelector('.im-sh'), card = root.querySelector('.im-tb__card'), tabs = root.querySelector('.im-tb__tabs'), moreEl = root.querySelector('[data-im-shmore]');
      function draw() { keepFocus(card, function () { card.innerHTML = P.card(false); }); moreEl.innerHTML = P.more(); refit(); }
      function show(k) { if (k === P.ST.k || !list.some(function (f) { return f.k === k; })) return; P.pick(k); tbSelect(tabs, k); draw(); }
      draw(); mark(root); P.wire(card, draw);
      d.__imShow = show;   // a closed menu follows "Your iPod" when it changes (see the imods:yours listener)
      tabsRule(tabs, function () { return P.ST.k; }, show, function (k) { var f = famOf(k); return f.refurb || atBuild(BUILD + f.k); });
      if (window.imodsMenusTest) window.imodsMenusTest.shop = P;
    }
    function phoneShop(d) {
      var list = shopFams(); if (!list.length) return;
      var P = shPicker();
      phoneFlow(d, 'All iPods', function () {
        return '<a class="im-btn im-btn--block" href="/collections/ipods-for-sale">Start your build</a>' + tiles(list, true) + REP +
          '<p class="im-mp-links"><a class="im-mp-more" href="/collections/ipods-for-sale#browse">Every refurbished iPod</a><a class="im-mp-more" href="/collections/ipod-flash-mods#built">Flash-modded iPods</a></p>';
      }, function (k) {
        P.pick(k);
        return '<div class="im-tb im-sh im-sh--phone" data-im-step2card>' + P.card(true) + '</div>';
      });
      var body = d.querySelector('.im-drawer__subbody'); if (!body) return;
      P.wire(body, function () { var h = body.querySelector('[data-im-step2card]'); if (h) keepFocus(h, function () { h.innerHTML = P.card(true); }); });
    }

    // ---- Flash Mods (owner idea §26; R2-1 "use", name pick "Flash Mods + service line", R2-1b "keep" = tabs). The eight iPods we
    // flash-mod; one shows its flash choices with installed prices (storage, battery where offered, the $129 music transfer) and ONE
    // button to its flash page with those choices made (?variant=, &music=1 ticks the transfer there). No Add to cart in the menu.
    // Prices: the installed-only variants written by snippets/imods-menu-flash.liquid from the products themselves (live), the music
    // transfer read live from /products/flash-mod-music-transfer.js; never the static menu data.
    var FM = null, FMA = null, fmaP = null;
    function fmData() {
      if (FM) return FM;
      var el = imods.$('[data-im-fm-data]'), j = null; if (!el) return null;
      try { j = JSON.parse(el.textContent); } catch (e) { return null; }
      var out = { order: [], m: {} }, capGb = function (cap) { var x = imods.units.capOf(cap); return x ? x.gb : 0; };
      Object.keys(j.m || {}).forEach(function (k) {
        var x = j.m[k]; if (!x || !x.v || !x.v.length) return;
        var st = [], by = {};
        x.v.forEach(function (t) {   // [variant id, price in cents, capacity, battery value]
          if (!by[t[2]]) { by[t[2]] = { cap: t[2], bats: [] }; st.push(by[t[2]]); }
          by[t[2]].bats.push({ val: t[3] || 'No', id: t[0], price: t[1] });
        });
        st.sort(function (a, b) { return capGb(a.cap) - capGb(b.cap); });
        out.m[k] = { k: k, h: x.h, img: x.img, no: x.no, yr: x.yr, storage: st }; out.order.push(k);
      });
      return (FM = out);
    }
    function fmAddon() {   // its own product, in no collection (so not in the menu snippet): read live once, on first use
      if (!fmaP) fmaP = fetch('/products/flash-mod-music-transfer.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (p) { var v = (p.variants || []).filter(function (x) { return x.available; })[0]; FMA = v ? { id: v.id, price: v.price } : null; return FMA; })
        .catch(function () { FMA = null; return null; });
      return fmaP;
    }
    function fmSOf(mm, cap) { return mm.storage.filter(function (s) { return s.cap === cap; })[0] || mm.storage[0]; }
    function fmVOf(s, bat) { return s.bats.filter(function (b) { return b.val === bat; })[0] || s.bats[0]; }
    function fmBase(s) { return (s.bats.filter(function (b) { return /^no$/i.test(b.val); })[0] || s.bats[0]).price; }
    function fmFrom(mm) { return Math.min.apply(null, mm.storage.map(fmBase)); }
    function fmBat(v) { return /^no$/i.test(v) ? 'Keep my battery' : /2000/.test(v) ? '2000mAh extended-life' : /1200/.test(v) ? '1200mAh extended-life' : 'New battery'; }
    function fmFirst(F) { var y = yours(); return F.m[MEM.fam] ? MEM.fam : (y && F.m[y] ? y : (F.m['5G'] ? '5G' : F.order[0])); }
    function fmPicker(F) {
      var ST = { k: null, cap: null, bat: 'No', music: false };
      function m() { return F.m[ST.k]; }
      function pick(k) { ST.k = k; ST.cap = m().storage[0].cap; ST.bat = 'No'; ST.music = false; }
      function rows() {
        var mm = m(), s = fmSOf(mm, ST.cap), v = fmVOf(s, ST.bat), b0 = fmBase(s);
        return tbRow('Storage', '<div class="im-tb-chips">' + mm.storage.map(function (x) { return chip('cap', x.cap, '<b>' + esc(x.cap) + '</b><small>' + money(fmBase(x)) + '</small>', x.cap === s.cap); }).join('') + '</div>') +
          tbRow('Battery', '<div class="im-tb-chips">' + s.bats.map(function (b) { var dl = b.price - b0; return chip('bat', b.val, '<b>' + fmBat(b.val) + '</b>' + (dl > 0 ? '<small>+' + money(dl) + '</small>' : ''), b.val === v.val); }).join('') + '</div>') +
          (FMA ? tbRow('Your music', '<div><label class="im-tb-tick"><input type="checkbox" data-music' + (ST.music ? ' checked' : '') + '> <span>Add music transfer <b>+' + money(FMA.price) + '</b></span></label>' +
            '<p class="im-tb-note">If your old drive still reads, we copy everything on it onto the new flash storage.</p></div>') : '');
      }
      function buy() {
        var mm = m(), s = fmSOf(mm, ST.cap), v = fmVOf(s, ST.bat), mu = ST.music && FMA, tot = v.price + (mu ? FMA.price : 0);
        var what = s.cap + ' · ' + fmBat(v.val).replace('Keep my battery', 'your own battery') + (mu ? ' · music transfer' : '');
        var href = '/products/' + mm.h + '?variant=' + v.id + (mu ? '&music=1' : '');
        var bh = atBuild(BUILD + ST.k + '&cap=' + encodeURIComponent(mm.storage[0].cap + ' flash mod'));
        return '<div class="im-tb-buy"><p class="im-tb-price">' + money(tot) + '</p><p class="im-tb-price__sub">Installed by iMods · ' + esc(what) + '</p>' +
          '<a class="im-btn im-tb-go" href="' + esc(href) + '">Continue with these choices</a><a class="im-tb-alt" href="' + esc(bh) + '">Or buy one already flash-modded ›</a></div>';
      }
      function card(phone) {
        var mm = m();
        if (phone) return '<div class="im-tb-id">' + tbPic(mm.img, 240, 'im-tb-id__pic') + '<div><p class="im-tb-id__name">' + esc(SHORT[ST.k]) + '</p><p class="im-tb-id__meta">Flash mod, installed by iMods</p></div></div>' +
          '<div class="im-tb-opts">' + rows() + '</div>' + buy();
        return '<div class="im-fm__body"><div class="im-tb-id">' + tbPic(mm.img, 240, 'im-tb-id__pic') + '<p class="im-tb-id__name">' + esc(SHORT[ST.k]) + '</p><p class="im-tb-id__meta">' + esc(mm.no + ' · ' + mm.yr) + '</p>' +
          '<a class="im-tb-id__link" href="/products/' + esc(mm.h) + '">About this flash mod ›</a></div><div class="im-tb-opts">' + rows() + '</div>' + buy() + '</div>';
      }
      function wire(root, redraw) {
        root.addEventListener('click', function (e) {
          var t = e.target.closest('[data-cap],[data-bat]'); if (!t || !root.contains(t)) return;
          if (t.hasAttribute('data-cap')) ST.cap = t.getAttribute('data-cap'); else ST.bat = t.getAttribute('data-bat');
          redraw();
        });
        root.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-music]')) { ST.music = e.target.checked; redraw(); } });
      }
      return { ST: ST, pick: pick, card: card, wire: wire };
    }
    function fmTabs(F, sel) {
      return '<ul class="im-tb__tabs" role="tablist" aria-label="Choose your iPod">' + F.order.map(function (k) {
        return '<li role="presentation"><button type="button" role="tab" class="im-tb__tab" data-k="' + k + '" aria-selected="' + (k === sel) + '">' + tbPic(F.m[k].img, 96, 'im-tb__pic') + '<b>' + esc(TILE[k]) + '</b><small>from ' + money(fmFrom(F.m[k])) + '</small><span data-im-tagslot></span></button></li>';
      }).join('') + '</ul>';
    }
    function deskFlash(d) {
      var F = fmData(), root = imods.$('[data-im-fm]', d), slot = root && imods.$('[data-im-fm-slot]', root);
      if (!F || !F.order.length || !slot) return;
      var P = fmPicker(F), sel = fmFirst(F); P.pick(sel);
      slot.innerHTML = fmTabs(F, sel) + '<div class="im-tb__card" role="tabpanel"></div>';
      var card = slot.querySelector('.im-tb__card'), tabs = slot.querySelector('.im-tb__tabs');
      function draw() { keepFocus(card, function () { card.innerHTML = P.card(false); }); refit(); }
      function show(k) { if (k === P.ST.k || !F.m[k]) return; P.pick(k); tbSelect(tabs, k); draw(); }
      draw(); mark(slot); P.wire(card, draw);
      d.__imShow = show;
      tabsRule(tabs, function () { return P.ST.k; }, show, function (k) { return '/products/' + F.m[k].h; });
      fmAddon().then(function () { draw(); });
      if (window.imodsMenusTest) window.imodsMenusTest.flash = P;
    }
    function phoneFlash(d) {
      var F = fmData(); if (!F || !F.order.length) return;
      var P = fmPicker(F);
      phoneFlow(d, 'All iPods', function () {
        return '<p class="im-tb-mplead">Flash Mod Service — installed by iMods. Pick your iPod:</p><ul class="im-mp-grid" role="list">' + F.order.map(function (k) {
          return '<li><button type="button" class="im-mp-tile" data-pick="' + k + '" data-k="' + k + '">' + tbPic(F.m[k].img, 120, 'im-m-pic') + '<span class="im-mp-tile__t">' + esc(TILE[k]) + '<small>from ' + money(fmFrom(F.m[k])) + '</small><span data-im-tagslot></span></span></button></li>';
        }).join('') + '</ul><p class="im-mp-links"><a class="im-mp-more" href="/collections/ipod-flash-mods">How a flash mod works</a></p>';
      }, function (k) {
        P.pick(k);
        return '<div class="im-tb im-fm im-fm--phone" data-im-step2card>' + P.card(true) + '</div>';
      });
      var body = d.querySelector('.im-drawer__subbody'); if (!body) return;
      var redraw = function () { var h = body.querySelector('[data-im-step2card]'); if (h) keepFocus(h, function () { h.innerHTML = P.card(true); }); };
      P.wire(body, redraw);
      fmAddon().then(redraw);
    }
    function repairYours(d) {
      var y = yours();
      imods.$$('.im-mrs-fam', d).forEach(function (li) { var on = li.getAttribute('data-k') === y; li.classList.toggle('is-yours', on); var t = li.querySelector('.im-mrs-yours'); if (t) t.hidden = !on; });
      // B11 (symptoms-1, 2026-10-02): "Your iPod" marks its family tab and opens it, until the visitor picks a tab themselves
      imods.$$('[data-im-mrx]', d).forEach(function (m) {
        var fam = null;
        imods.$$('.im-mrx-tab, option[data-keys]', m).forEach(function (t) {
          var on = !!y && (' ' + t.getAttribute('data-keys') + ' ').indexOf(' ' + y + ' ') >= 0;
          if (on) fam = t.getAttribute('data-fam') || t.value;
          var b = t.querySelector && t.querySelector('.im-mrx-yours'); if (b) b.hidden = !on;
        });
        if (fam && !m.hasAttribute('data-touched')) {
          var r = m.querySelector('.im-mrx-r[value="' + fam + '"]'); if (r) r.checked = true;
          var sel = m.querySelector('[data-im-mrx-select]'); if (sel) sel.value = fam;
          imods.mrxSync(m);
        }
        // a two-model family's part links go to "Your iPod"'s own collection when it is one of the two (else the all-models one)
        imods.$$('a[data-by-model]', m).forEach(function (a) {
          if (!a.hasAttribute('data-href0')) a.setAttribute('data-href0', a.getAttribute('href'));
          var hit = null;
          a.getAttribute('data-by-model').split(';').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0 && kv.slice(0, i) === y) hit = kv.slice(i + 1); });
          a.setAttribute('href', hit || a.getAttribute('data-href0'));
        });
      });
    }
    function renderAll() {
      imods.$$('[data-im-nav] details[data-im-mega], [data-im-drawer] details[data-im-mega]').forEach(function (d) {
        var kind = d.getAttribute('data-im-mega'), phone = !!d.closest('[data-im-drawer]');
        try {
          if (kind === 'parts') { if (phone) phoneParts(d); else deskParts(d); initSearch(d); }
          else if (kind === 'shop') { if (phone) phoneShop(d); else deskShop(d); }
          else if (kind === 'flash') { if (phone) phoneFlash(d); else deskFlash(d); }   // menus round 2 (owner §27 R2-1)
          // FIX-10 set 9 (b), owner pick R1 "How it works": the Repair menu is server-rendered (snippets/imods-menu-repair.liquid);
          // no iPod strip, no per-iPod prices (the Parts menu has them) and no "Your iPod" pick here
          // FIX-10 set 11 (owner round 6 "S1 Symptom, then iPod"): the menu stays server-rendered; the JS marks "Your iPod"
          if (kind === 'repair') repairYours(d);
          var panel = d.querySelector('.im-panel, .im-drawer__subbody'); if (panel) panel.setAttribute('data-im-ready', '');
        } catch (err) { if (window.console) console.warn('imods menus:', kind, err); }
      });
      done = true;
      document.dispatchEvent(new CustomEvent('imods:menus-ready'));
    }
    document.addEventListener('imods:yours', function (e) {
      if (!done) return;
      imods.$$('[data-im-nav], [data-im-drawer]').forEach(mark);
      imods.$$('details[data-im-mega="repair"]').forEach(repairYours);
      var k = e.detail && e.detail.key;
      if (k) imods.$$('[data-im-nav] details[data-im-mega]').forEach(function (d) { if (d.__imShow && !d.open) d.__imShow(k); });
    });

    function ensure() {
      if (started) return;
      started = true;
      imods.data().then(function (d) { D = d; context(); if (!MEM.fam) MEM.fam = yours(); renderAll(); })
        .catch(function () { started = false; }); // the server-rendered links stay; the next intent tries again
    }
    // live deep links (?panel=create|parts|services&model=&part=) open that panel on desktop; the builder page reads its own
    function deepLink() {
      var q = params, panel = q.get('panel'); if (!panel || /^\/collections\/ipods-for-sale/.test(location.pathname)) return;
      var kind = { create: 'shop', parts: 'parts', services: 'repair' }[panel]; if (!kind) return;
      // FIX-10 set 11: ?panel=services replaces Start your repair's links (owner round 6: the page retires), so on a phone it
      // opens the drawer at iPod Repair (the symptom menu) instead of doing nothing
      if (!window.matchMedia('(min-width: 990px)').matches) {
        if (kind !== 'repair') return;
        var dr = imods.$('[data-im-drawer]'), sub = dr && dr.querySelector('details[data-im-mega="repair"]');
        if (!dr || !sub) return;
        dr.setAttribute('open', ''); sub.setAttribute('open', ''); ensure();
        return;
      }
      var d = imods.$('[data-im-nav] details[data-im-mega="' + kind + '"]'); if (!d) return;
      var model = q.get('model'), part = (q.get('part') || '').replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      if (model && SHORT[model]) MEM.fam = model;
      if (part && ICON[part]) MEM.part = part;
      d.setAttribute('open', '');
      ensure();
    }
    // FIX-4 (N-17): the Repair menu cell's own "from … installed" rule, shared so the repair page's part buttons price the
    // part itself the same way (bumpers, cables, center buttons and glass lenses stay out of the "from" price)
    function fromInstalled(part, ps) { return ps && ps.length ? low(driveOnly(part, ps), true) : null; }
    return { ensure: ensure, deepLink: deepLink, mem: MEM, fromInstalled: fromInstalled };
  })();

  // ---- sticky header offset, so the section rail sits under a revealed header
  // FIX-10 set 7 (b) (FINDINGS #10): the offset follows the header's state (Dawn's sticky-header classes) and its full
  // height, not its sliding position: read during the 0.15 s reveal it said 0 px, so a revealed header covered the rail
  // and the next tap hit the header. It updates on every class change too (the header reveals in its own frame).
  // An in-page jump (a rail link, a tab) keeps the header hidden (Dawn's own preventHeaderReveal) and lands under nothing.
  // 2026-11-03 (owner list "build header offset"): a hidden header is NOT always gone. Dawn slides the section up by
  // --header-height, measured when the sticky header connects, before assets/imods-cb.js shows the phone My iPod bar
  // (.cb-mybar, below 990 px), so the bar stays at the top while the header is hidden; the offset said 0 and every sticky
  // row and jump target sat under the bar. Hidden, the offset is the part of the section that stays on screen (its height
  // minus --header-height: the bar, or 0 where no bar shows), from the state, not the sliding position.
  function initHeaderOffset() {
    var sec = document.querySelector('.section-header');
    if (!sec) return;
    var raf = 0, root = document.documentElement;
    function rest() {
      var hh = parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) || 0;
      return Math.max(0, Math.round(sec.getBoundingClientRect().height - hh));
    }
    function upd() {
      raf = 0;
      var hidden = sec.classList.contains('shopify-section-header-hidden');
      var sticky = sec.classList.contains('shopify-section-header-sticky');
      var off = hidden ? rest() : sticky ? Math.round(sec.getBoundingClientRect().height) : 0;
      root.style.setProperty('--im-header-offset', Math.max(0, off) + 'px');
    }
    function soon() { if (!raf) raf = requestAnimationFrame(upd); }
    window.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    if ('MutationObserver' in window) new MutationObserver(upd).observe(sec, { attributes: true, attributeFilter: ['class'] });
    imods.holdHeader = function () {
      var sh = document.querySelector('sticky-header');
      if (sh) sh.dispatchEvent(new Event('preventHeaderReveal'));
      // the header is about to hide (past it, a jump never reveals it): the jump lands as if it were hidden already
      if (sec.classList.contains('scrolled-past-header') || sec.classList.contains('shopify-section-header-sticky')) root.style.setProperty('--im-header-offset', rest() + 'px');
      setTimeout(soon, 400);   // then the header's real state again (a jump that could not move the page leaves it shown)
    };
    upd();
  }

  // ---- FIX-10 set 7 (g), owner 2026-09-29 "Move only when needed" (FINDINGS #9: the builders moved the page after every
  // pick): an element that a pick opens stays where it is while it is on screen (its top below the header, and `need` px of
  // it in view above the bottom edge; on a phone above the chat button's corner). Otherwise the page moves once, bringing its
  // top just under the header (Dawn shows the header when the page moves up, hides it when it moves down). True if it moved.
  imods.bringIntoView = function (el, opts) {
    if (!el || el.hidden || !el.getBoundingClientRect) return false;
    opts = opts || {};
    var r = el.getBoundingClientRect(), phone = window.matchMedia('(max-width: 749px)').matches;
    var top0 = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--im-header-offset')) || 0;
    var room = window.innerHeight - (phone ? 88 : 0), need = Math.min(r.height, opts.need || 160);
    if (r.top >= top0 && r.top + need <= room) return false;
    var hd = document.querySelector('.section-header'), up = r.top < top0 || r.top < 0;
    var off = (up && hd ? hd.getBoundingClientRect().height : 0) + 12;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, Math.round(r.top + window.scrollY - off)), behavior: reduce ? 'auto' : 'smooth' });
    return true;
  };

  // ---- section rail: real in-page links, aria-current follows the section in view (scroll-spy)
  function initRail() {
    imods.$$('[data-im-rail]').forEach(function (rail) {
      var links = imods.$$('a[href^="#"]', rail);
      var map = new Map();
      links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) map.set(t, a); });
      if (!map.size || !('IntersectionObserver' in window)) return;
      var current = null, inBand = new Set(), targets = Array.from(map.keys());
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { inBand.add(en.target); current = en.target; } else inBand.delete(en.target); });
        // G-15: above the first section (a jump back to the top) nothing is underlined
        if (!inBand.size && targets[0] && targets[0].getBoundingClientRect().top > window.innerHeight * 0.35) {
          current = null; links.forEach(function (a) { a.removeAttribute('aria-current'); }); return;
        }
        if (current) {
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          var a = map.get(current); a.setAttribute('aria-current', 'true');
          var ul = a.closest('ul');
          if (ul && ul.scrollWidth > ul.clientWidth) {
            var l = a.offsetLeft - 16;
            if (l < ul.scrollLeft || a.offsetLeft + a.offsetWidth > ul.scrollLeft + ul.clientWidth) ul.scrollTo({ left: l, behavior: 'auto' });
          }
        }
      }, { rootMargin: '-35% 0px -60% 0px' });
      map.forEach(function (_, t) { io.observe(t); });
      // FIX-10 set 7 (b): a jump from the rail does not bring the header back over the rail
      rail.addEventListener('click', function (e) { if (e.target.closest('a[href^="#"]') && imods.holdHeader) imods.holdHeader(); });
    });
  }

  // ---- DS-sticky-buy: hidden while the real Add to cart is on screen; reserves no space; a tap with a missing choice
  // scrolls to that choice (the page's own script decides, through the "imods:sticky-tap" event)
  imods.initSticky = function (bar, realBtn) {
    if (!bar || !realBtn || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var show = false;
    function upd() { bar.hidden = !mq.matches || !show; }
    // G-02: the bar shows after the real button leaves the viewport (scrolled past it), and hides while it is on screen.
    // The observer only fires when the button crosses the screen edge, so a jump past it (a link to a section, a restored
    // scroll position) is caught by a throttled scroll check as well.
    function calc() { show = realBtn.getBoundingClientRect().bottom < 0; upd(); }
    new IntersectionObserver(function (en) { var e = en[0]; show = !e.isIntersecting && e.boundingClientRect.bottom < 0; upd(); }, { threshold: 0 }).observe(realBtn);
    var ticking = false;
    window.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; calc(); }); }, { passive: true });
    mq.addEventListener('change', upd);
    var btn = bar.querySelector('button, a');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      var ev = new CustomEvent('imods:sticky-tap', { cancelable: true });
      if (bar.dispatchEvent(ev)) realBtn.click();
    });
    calc();
  };

  // ---- DS-error-block: one block, one sentence, one "Try again"
  imods.errorBlock = function (host, onRetry) {
    var old = host.querySelector('[data-imods-error]');
    if (old) old.remove();
    var d = document.createElement('div');
    d.className = 'im-error'; d.setAttribute('data-imods-error', ''); d.setAttribute('role', 'alert');
    d.innerHTML = '<p>Options failed to load. Your choices are still here.</p><button type="button" class="im-btn im-btn--secondary">Try again</button>';
    d.querySelector('button').addEventListener('click', function () { d.remove(); onRetry && onRetry(); });
    host.prepend(d);
    return d;
  };

  // ---- cart add (Ajax); returns the cart line or throws with a message; double submits are blocked by the caller
  imods.cartAdd = function (items) {
    return fetch((CFG.cartAdd || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble' })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'The cart did not accept this item.');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && j.sections && j.sections['cart-icon-bubble']) {
          var tmp = document.createElement('div'); tmp.innerHTML = j.sections['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section') || tmp;
          bubble.innerHTML = inner.innerHTML;
        }
        return j;
      });
    });
  };

  // ---- the one Add-ons panel (owner R-2026-09-26-27, R-2026-09-27-03, -05). The product page (imods-buybox.js) and the
  // cart's "Change choices" (imods-cartedit.js) both draw it, so a tick maps to the same store variant in both places.
  // One box with lined rows: the plain add-ons (battery, click wheel, pre-installed bundles, the flash kits' "Add a new
  // battery"), ONE "Flash storage upgrade" row whose sizes open under it, and the box and prepaid label (We Fix It only).
  // The store's options are unchanged (the restructure is R31); combined battery + flash values are used while
  // rules addons.flashCombo = 'allow'. The caller wires change events to handle() and re-renders when it returns true.
  //   o = { roles: [role per option index], vals: [[values] per index], sel: () => selection (live array), set: (i, v),
  //         price: (selection) => cents|null, installed: () => bool, isInstall: (v) => bool, comboMode, uid,
  //         formId (cart: keeps the inputs off Dawn's cart form), boxLabel, flashNote }
  imods.addonPanel = function (o) {
    var esc = imods.esc, money = imods.money, $ = imods.$, $$ = imods.$$;
    function isNone(v) { return !v || /^none$/i.test(v) || /^no$/i.test(v); }
    function isYes(v) { return /^yes/i.test(v || ''); }
    function isFlashAddon(v) { return /flash mod (kit|service)/i.test(v || ''); }
    function isCombo(v) { return isFlashAddon(v) && /battery/i.test(v); }
    function isPlain(v) { return !isNone(v) && !isFlashAddon(v); }
    // FIX-9 set 6 (owner 2026-09-28 "Hide it under You Fix It"; R-2026-09-26-29 / R-2026-09-27-11 "no do it yourself part"):
    // the 2000mAh add-on (5th/6th/7th Gen flash kits) is offered with We Fix It only, installed
    function is2000(v) { return /2000\s?mah/i.test(v || ''); }
    function capOf(v) { var m = /(\d+)\s?(GB|TB)/i.exec(v || ''); return m ? { label: m[1] + m[2].toUpperCase(), gb: (+m[1]) * (m[2].toUpperCase() === 'TB' ? 1024 : 1) } : null; }
    function capKey(v) { var c = capOf(v); return c ? c.label : ''; }
    function kindOf(v) { return /service/i.test(v) ? 'service' : 'kit'; }
    function twinOf(v, vs) { if (!isFlashAddon(v)) return null; var t = /kit/i.test(v) ? v.replace(/kit/i, 'service') : v.replace(/service/i, 'kit'); return vs.indexOf(t) >= 0 ? t : null; }
    function name(v) {
      var n = String(v || '').replace(/^\+\s*/, '').replace(/^yes\s*-\s*/i, '').replace(/\s*\([^)]*\)\s*$/, '');
      n = n.replace(/flash mod (kit|service)/i, 'flash mod').replace(/\s*\+\s*battery/i, ' and new battery');
      return n.charAt(0).toUpperCase() + n.slice(1);
    }
    // W6 (owner section 38, 2026-10-17): the battery add-on reads "+ New battery (5% off, 25% off with We Fix It)": the badge names the
    // saving of the chosen fix (We Fix It = installed); a value with one saving, e.g. "(5% off)", keeps its own words. Feed fix: the words
    // come from imods.saveWords (the value's own brackets, else the saving list)
    function saveOf(v, inst) {
      var w = imods.saveWords(v); if (!w) return '';
      var ps = w.split(/\s*,\s*/), we = ps.filter(function (p) { return /with we fix it/i.test(p); })[0];
      if (!we) return /off$/i.test(w) ? w : '';
      return inst ? we.replace(/\s*with we fix it\s*$/i, '') : (ps.filter(function (p) { return p !== we; })[0] || '');
    }
    function noneAt(i) { return o.vals[i].filter(isNone)[0]; }
    var roles = o.roles, comboMode = o.comboMode || 'block';
    var U = -1;
    roles.forEach(function (r, i) { if (U < 0 && r === 'addon' && o.vals[i].some(isFlashAddon)) U = i; });
    var iBox = roles.indexOf('box'), iSvc = roles.indexOf('service');
    var svcInst = iSvc >= 0 ? o.vals[iSvc].filter(function (v) { return o.isInstall(v) && !/box|label/i.test(v); })[0] : null;
    var svcBox = iSvc >= 0 ? o.vals[iSvc].filter(function (v) { return o.isInstall(v) && /box|label/i.test(v); })[0] : null;
    var plain = [];
    roles.forEach(function (r, i) {
      if (r === 'addon' || r === 'addbattery') o.vals[i].filter(isPlain).forEach(function (v) { plain.push({ i: i, v: v }); });
    });
    var sizes = U >= 0 ? o.vals[U].filter(function (v) { return isFlashAddon(v) && !isCombo(v); })
      .sort(function (a, b) { return (capOf(a) || { gb: 0 }).gb - (capOf(b) || { gb: 0 }).gb; }) : [];
    var box = iBox >= 0 ? { i: iBox, yes: o.vals[iBox].filter(isYes)[0], no: o.vals[iBox].filter(function (v) { return !isYes(v); })[0] }
      : (svcBox && svcInst ? { i: iSvc, yes: svcBox, no: svcInst } : null);
    if (!plain.length && !sizes.length && !box) return null;

    function sel() { return o.sel(); }
    function at(i, v) { var c = sel().slice(); c[i] = v; return c; }
    function flashPart(v) { if (!isCombo(v)) return v; return sizes.filter(function (x) { return capKey(x) === capKey(v) && kindOf(x) === kindOf(v); })[0] || null; }
    // only "+ New battery" pairs with a flash size (the combined "flash + battery" values); "Headphone jack and battery
    // pre-installed" also names a battery but has no combined value
    function isNewBattery(v) { return /^\+?\s*new battery/i.test(v || ''); }
    function batteryInU() { return U >= 0 ? o.vals[U].filter(function (x) { return isPlain(x) && isNewBattery(x); })[0] || null : null; }
    function comboOf(p, f) {
      if (comboMode !== 'allow' || U < 0 || !p || !isNewBattery(p) || !f) return null;
      return o.vals[U].filter(function (x) { return isCombo(x) && capKey(x) === capKey(f) && kindOf(x) === kindOf(f); })[0] || null;
    }
    function plainAt(it) { var v = sel()[it.i]; if (v === it.v) return true; return it.i === U && isCombo(v) && batteryInU() === it.v; }
    function plainU() { var v = sel()[U]; if (isPlain(v)) return v; if (isCombo(v)) return batteryInU(); return null; }
    function flashNow() { if (U < 0) return null; var v = sel()[U]; if (isCombo(v)) return flashPart(v); return isFlashAddon(v) ? v : null; }
    // I-23 (owner 2026-10-11 "still seeing the flash mod 128gb ... under you fix"): the DIY kits are gone, so a flash SERVICE add-on
    // has no kit twin any more; it is installed only and never shows under You Fix It
    function sizeShown(v) { var tw = twinOf(v, o.vals[U]); if (tw) return o.installed() ? /service/i.test(v) : /kit/i.test(v); return kindOf(v) === 'service' ? o.installed() : true; }
    var noteMsg = '';
    function setU(p, f, changed) {
      var v = comboOf(p, f);
      noteMsg = '';
      if (!v) {
        if (p && f) {                                       // 'block': one replaces the other, the latest pick wins
          if (changed === 'plain') f = null; else p = null;
          noteMsg = 'That add-on and a flash upgrade can\'t be combined on this part: choose one.';
        }
        v = f || p || noneAt(U);
      }
      o.set(U, v);
    }
    // the flash price of size v on top of what is ticked now (with the battery ticked, the combined value)
    function flashAdd(v) {
      var p = plainU(), withF = comboOf(p, v) || v, baseF = comboOf(p, v) ? p : noneAt(U);
      var a = o.price(at(U, withF)), b = o.price(at(U, baseF));
      return a != null && b != null ? a - b : null;
    }
    function plainAdd(it) {
      if (it.i !== U) { var a0 = o.price(at(it.i, it.v)), b0 = o.price(at(it.i, noneAt(it.i))); return a0 != null && b0 != null ? a0 - b0 : null; }
      var f = flashNow(), c = comboOf(it.v, f);            // with a flash size ticked: the combined value over the size alone
      var a = o.price(at(U, c || it.v)), b = o.price(at(U, c ? f : noneAt(U)));
      return a != null && b != null ? a - b : null;
    }
    function onNames() {
      var out = plain.filter(plainAt).map(function (it) { return name(it.v); });
      if (flashNow()) out.push('Flash storage upgrade');
      return out;
    }
    function title(t, save) { return esc(t) + (save ? ' <sup class="im-save">' + esc(save) + '</sup>' : ''); }

    // ---- draw
    var fa = o.formId ? ' form="' + esc(o.formId) + '"' : '';
    // FIX-9 set 8 (owner 2026-09-28: "add the box option to its own section instead of the Add-ons since the adds are for
    // additional parts"; heading "Shipping your iPod to us"): two fieldsets, Add-ons and the box, in one wrapper that takes
    // no box of its own (display: contents), so the product form's flex order (7) and the cart slot still hold them
    var el = document.createElement('div');
    el.className = 'im-addons-wrap'; el.style.display = 'contents';
    var fsA = document.createElement('fieldset');
    fsA.className = 'im-fieldset im-addons'; fsA.setAttribute('data-virt-addons', ''); fsA.style.order = '7';
    // owner 2026-09-28 ("Your words"): the heading says whether the add-ons come installed or as parts, following the fix method
    // (one inner span: .im-legend is a space-between flex row, so two items would push the words to the far right)
    var h = '<legend class="im-legend"><span>Add-ons <span data-virt-how></span></span></legend><div class="im-addlist">';
    plain.forEach(function (it, n) {
      h += '<label class="im-addrow im-choice" data-virt-row="plain"><input type="checkbox"' + fa + ' data-virt-i="' + n + '"><span class="im-addrow__t" data-label></span><span class="im-addrow__p" data-price></span></label>';
    });
    if (sizes.length) {
      h += '<div class="im-addrow-group" data-virt-flash><label class="im-addrow im-choice" data-virt-row="flash"><input type="checkbox"' + fa + ' data-virt-flash-toggle><span class="im-addrow__t" data-label></span><span class="im-addrow__p" data-price></span></label>' +
        '<div class="im-addsizes" role="radiogroup" aria-label="Flash storage size" data-virt-sizes hidden>' +
        sizes.map(function (v, k) { return '<label class="im-chip im-choice im-addsize" data-virt-size-row="' + k + '"><input type="radio"' + fa + ' name="' + esc(o.uid) + '-fsize" data-virt-size="' + k + '"><span data-label>' + esc(capKey(v)) + '</span><small data-price></small></label>'; }).join('') +
        '</div>' + (o.flashNote ? '<p class="im-addrow__note">' + esc(o.flashNote) + '</p>' : '') + '</div>';
    }
    h += '</div><p class="im-decision im-addons__note" data-virt-note hidden></p>';
    fsA.innerHTML = h; el.appendChild(fsA);
    var fsB = null;
    if (box) {
      fsB = document.createElement('fieldset');
      fsB.className = 'im-fieldset im-addons im-boxsec'; fsB.setAttribute('data-virt-boxsec', ''); fsB.style.order = '7';
      fsB.innerHTML = '<legend class="im-legend">Add protective box and prepaid shipping label</legend><div class="im-addlist">' +
        '<label class="im-addrow im-choice" data-virt-row="box"><input type="checkbox"' + fa + ' data-virt-box><span class="im-addrow__t" data-label></span><span class="im-addrow__p" data-price></span></label>' +
        '</div><p class="im-addons__note">Or pack it yourself: the mailing instructions come in your confirmation email.</p>';   // plain text: an inline link would be a 21 px target (SPEC 44 px)
      el.appendChild(fsB);
    }

    return {
      el: el,
      // before the caller resolves the variant: kit <-> service twin follows the fix method; the box only with We Fix It
      normalize: function () {
        var s = sel(), inst = o.installed();
        roles.forEach(function (r, i) {
          if (r !== 'addon' || !isFlashAddon(s[i])) return;
          var tw = twinOf(s[i], o.vals[i]); if (tw && (inst ? /kit/i.test(s[i]) : /service/i.test(s[i]))) o.set(i, tw);
          // I-23: a flash service with no kit twin comes off under You Fix It (a flash + battery value keeps the new battery)
          else if (!tw && !inst && kindOf(s[i]) === 'service') o.set(i, (isCombo(s[i]) && o.vals[i].filter(function (x) { return isPlain(x) && isNewBattery(x); })[0]) || noneAt(i));
        });
        if (box && box.i === iBox && !inst && s[iBox] === box.yes) o.set(iBox, box.no);
        if (!inst) plain.forEach(function (it) {
          if (is2000(it.v) && sel()[it.i] === it.v) o.set(it.i, noneAt(it.i) || o.vals[it.i].filter(function (v) { return !isYes(v); })[0]);
        });
      },
      boxOn: function () { return !!box && sel()[box.i] === box.yes; },
      handle: function (t) {
        if (!el.contains(t)) return false;
        var before = onNames(), picked = null;
        if (t.hasAttribute('data-virt-i')) {
          var it = plain[+t.getAttribute('data-virt-i')];
          if (it.i === U) setU(t.checked ? it.v : null, flashNow(), 'plain');
          else { noteMsg = ''; o.set(it.i, t.checked ? it.v : noneAt(it.i)); }
          if (t.checked) picked = name(it.v);
        } else if (t.hasAttribute('data-virt-flash-toggle')) {
          var first = sizes.filter(function (v) { return sizeShown(v) && !(flashAdd(v) < 0); })[0] || null;
          setU(plainU(), t.checked ? first : null, 'flash');
          if (t.checked) picked = 'Flash storage upgrade';
        } else if (t.hasAttribute('data-virt-size')) {
          setU(plainU(), sizes[+t.getAttribute('data-virt-size')], 'flash');
          picked = 'Flash storage upgrade';
        } else if (t.hasAttribute('data-virt-box')) {
          o.set(box.i, t.checked ? box.yes : box.no);
        } else return false;
        // add-ons that share one store option are one at a time until the catalogue round (R31): say what a tick replaced
        var after = onNames(), lost = before.filter(function (n) { return after.indexOf(n) < 0 && n !== picked; });
        if (picked && lost.length) noteMsg = picked + ' replaces ' + lost.map(function (n) { return n.charAt(0).toLowerCase() + n.slice(1); }).join(' and ') + ': this part takes one of these at a time.';
        return true;
      },
      sync: function () {
        var inst = o.installed();
        $('[data-virt-how]', el).textContent = inst ? '(includes installation)' : '(includes part only)';
        plain.forEach(function (it, n) {
          var row = $('[data-virt-i="' + n + '"]', el).parentNode, add = plainAdd(it);
          $('input', row).checked = plainAt(it);
          row.hidden = (add != null && add < 0) || (!inst && is2000(it.v));   // R3 display guard: never "+-$"; 2000mAh installed only
          $('[data-label]', row).innerHTML = title(name(it.v), saveOf(it.v, inst));
          $('[data-price]', row).textContent = add != null ? '+' + money(add) : '';
        });
        if (sizes.length) {
          var grp = $('[data-virt-flash]', el), f = flashNow(), shown = [];
          sizes.forEach(function (v, k) {
            var r = $('[data-virt-size-row="' + k + '"]', el), add = flashAdd(v), ok = sizeShown(v) && !(add != null && add < 0);
            r.hidden = !ok; if (ok) shown.push(v);
            $('input', r).checked = f === v;
            $('[data-price]', r).textContent = add != null ? '+' + money(add) : '';
          });
          grp.hidden = !shown.length;
          var tg = $('[data-virt-flash-toggle]', el); tg.checked = !!f;
          $('[data-virt-sizes]', el).hidden = !f || shown.length < 2;     // one size: named in the row, no size buttons
          var ref = f || shown[0], addR = ref ? flashAdd(ref) : null;
          $('[data-label]', tg.parentNode).innerHTML = title('Flash storage upgrade' + (shown.length === 1 ? ': ' + capKey(shown[0]) : ''), saveOf(ref));
          $('[data-price]', tg.parentNode).textContent = addR == null ? '' : (f || shown.length === 1 ? '+' : 'from +') + money(addR);
        }
        if (box) {
          var br = $('[data-virt-box]', el).parentNode;
          br.hidden = !inst;
          $('[data-virt-box]', el).checked = sel()[box.i] === box.yes;
          var a = o.price(at(box.i, box.yes)), b = o.price(at(box.i, box.no));
          $('[data-label]', br).textContent = o.boxLabel || 'Send me a protective box and prepaid shipping label';
          $('[data-price]', br).textContent = a != null && b != null ? '+' + money(a - b) : '';
        }
        var nt = $('[data-virt-note]', el); nt.hidden = !noteMsg; nt.textContent = noteMsg;
        fsA.hidden = !$$('.im-addlist > [data-virt-row], .im-addlist > [data-virt-flash]', fsA).some(function (x) { return !x.hidden; });
        if (fsB) fsB.hidden = !inst;                        // a part we mail you needs no box: We Fix It only
        el.style.display = fsA.hidden && (!fsB || fsB.hidden) ? 'none' : 'contents';
      }
    };
  };

  // ---- "Chat with us": open the Shopify Inbox launcher (shopify-chat, its shadow button.activator, part="activator").
  // Implement-A A5 (work order, 2026-10-01): every chat link's href is the contact form, never an email client; while the
  // chat script is still loading the click waits up to 4 s for the launcher, then follows the href.
  // Design round 3 (F1, owner R3-5 "use", OWNER_ANSWERS_SITE_IDEAS.md §33; 2026-10-17): Shopify moved the launcher one shadow level
  // deeper (shopify-chat > #shadow > shopify-agent-runtime > #shadow > button.activator, seen 2026-10-08), so the one-level search
  // found nothing and every link went to the contact form after 4 s. The search now walks the open shadow roots under the host
  // (up to 5 levels), activator first; the old first-button fallback stays for an older widget. And the launcher click is DEFERRED
  // (setTimeout 0): Shopify's widget ignores a click fired inside another click's dispatch (round 3b test, 2026-10-17).
  function chatButton() {
    var el = document.querySelector('shopify-chat, inbox-online-store-chat, #shopify-chat');
    if (!el) return null;
    function deep(root, d) {
      if (!root || d > 4) return null;
      var b = root.querySelector('button.activator, button[part~="activator"], [part~="activator"]');
      if (b) return b;
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) { if (all[i].shadowRoot) { var x = deep(all[i].shadowRoot, d + 1); if (x) return x; } }
      return null;
    }
    var host = el.shadowRoot || el;
    return deep(host, 0) || host.querySelector('button');
  }
  imods.chatButton = chatButton;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-im-chat]');
    if (!b) return;
    e.preventDefault();
    var t0 = Date.now(), href = b.getAttribute('href');
    (function tryOpen() {
      var btn = null;
      try { btn = chatButton(); } catch (err) {}
      if (btn) { setTimeout(function () { btn.click(); }, 0); return; }
      if (Date.now() - t0 < 4000) return setTimeout(tryOpen, 150);
      if (href) window.location.assign(href);
    })();
  });
  // ---- copy buttons (contact page: the email address)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-im-copy]');
    if (!b) return;
    var v = b.getAttribute('data-im-copy'), was = b.textContent;
    function done(ok) { b.textContent = ok ? 'Copied' : 'Select and copy'; setTimeout(function () { b.textContent = was; }, 2000); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(function () { done(true); }, function () { done(false); });
    else done(false);
  });

  // ---- FIX-10 set 13 e (owner 2026-09-30, Codex review B5): the free diagnostic opens on the iPod already named (the link's
  // ?variant= from a model's page, else "Your iPod"); with neither, the Model list asks "Choose your iPod" and Add to cart and the
  // express buttons wait for a pick (the page used to open on the 7th Gen). A box choice made first is kept, not sent to the store.
  function initDiagAsk() {
    if (!/^\/products\/free-ipod-diagnostic-service\/?$/.test(location.pathname) || params.get('variant')) return;
    var sel = imods.$('variant-selects select[data-position="1"]'), form = sel && document.getElementById(sel.getAttribute('form'));
    var btn = form && form.querySelector('[type="submit"][name="add"]'), txt = btn && btn.querySelector('span');
    if (!sel || !btn) return;
    var VAL = { '3G': '3rd generation iPod classic (A1040)', '4G': '4th generation iPod classic (A1059)', 'Photo': '4th generation iPod photo (A1099)',
      '5G': '5th generation iPod video (A1136)', '6G': '6th generation iPod classic (A1238)', '7G': '7th generation iPod classic (A1238)',
      'Mini1': '1st generation iPod mini (A1051)', 'Mini2': '2nd generation iPod mini (A1051)' };
    var y = imods.yours.get(), want = y && VAL[y.key];
    if (want && [].some.call(sel.options, function (o) { return o.value === want; })) {
      if (sel.value === want) return;
      Promise.all(['variant-selects', 'product-info', 'product-form'].map(function (n) { return customElements.whenDefined(n); })).then(function () {
        sel.value = want; sel.dispatchEvent(new Event('change', { bubbles: true }));   // Dawn's own change: variant, price, URL
      });
      return;
    }
    [].forEach.call(sel.options, function (o) { o.removeAttribute('selected'); });
    var ph = document.createElement('option');
    ph.value = ''; ph.disabled = true; ph.textContent = 'Choose your iPod'; ph.setAttribute('selected', 'selected'); ph.setAttribute('data-im-choose', '');
    sel.insertBefore(ph, sel.firstChild); sel.selectedIndex = 0;
    var was = txt ? txt.textContent : '', pay = form.querySelector('.shopify-payment-button'), asking = true;
    btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('data-im-held', ''); if (txt) txt.textContent = 'Choose your iPod above';
    if (pay) { pay.setAttribute('inert', ''); pay.style.opacity = '.45'; }
    btn.addEventListener('click', function (e) {
      if (!asking) return;
      e.preventDefault(); sel.focus(); try { sel.showPicker(); } catch (err) {}
    });
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!asking || !t || t.tagName !== 'SELECT' || !t.closest('variant-selects')) return;
      if (t === sel) {
        if (!sel.value) return;
        asking = false; btn.removeAttribute('aria-disabled'); btn.removeAttribute('data-im-held'); if (txt) txt.textContent = was;
        if (pay) { pay.removeAttribute('inert'); pay.style.opacity = ''; }
        return;   // Dawn's change handler goes on to fetch the chosen variant
      }
      e.stopPropagation();   // no model yet: keep the box choice as Dawn marks it, without asking the store for a variant
      [].forEach.call(t.options, function (o) { o.removeAttribute('selected'); });
      if (t.selectedOptions[0]) t.selectedOptions[0].setAttribute('selected', 'selected');
    }, true);
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  // nav round 2026-10-21 (planning session's refined plan, item 2; the owner marks it in the before/after round): a component page
  // (/collections/ipod-<part>-replacement, no iPod tag: sections/imods-part-type.liquid) opened with ?fix=part or ?fix=installed passes it
  // on to each iPod card, so the iPod + part page opens with that fix method picked (assets/imods-sib.js reads it there). Only the
  // links in the browser change: the page's server HTML and its canonical stay clean.
  function initFixHandoff() {
    var fx = params.get('fix');
    if (fx !== 'part' && fx !== 'installed') return;
    if (!/^\/collections\/ipod-[a-z-]+-replacement\/?$/.test(location.pathname)) return;
    imods.$$('a.im-pt-model:not(.im-pt-model--x)').forEach(function (a) {
      var u = new URL(a.getAttribute('href'), location.origin);
      u.searchParams.set('fix', fx);
      a.setAttribute('href', u.pathname + u.search + u.hash);
    });
  }
  ready(function () {
    initNav(); initDrawer(); initHeaderOffset(); initRail(); imods.yours.render(); imods.menus.deepLink(); initDiagAsk(); initFixHandoff();
    imods.$$('[data-imods-sticky]').forEach(function (bar) {
      var real = document.querySelector(bar.getAttribute('data-for'));
      imods.initSticky(bar, real);
    });
  });
})();

/* ---- number finder (D-02 B home, repair step 1, search): "Find your iPod by the number on the back" ---- */
(function () {
  function lookup() {
    var el = document.getElementById('imods-model-lookup');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function norm(q) {
    q = String(q || '').toUpperCase().replace(/\s+/g, '');
    if (/^M[A-C]?\d{3,4}LLA$/.test(q)) q = q.replace(/LLA$/, 'LL/A');
    if (/^M[A-C]?\d{3,4}$/.test(q)) q = q + 'LL/A';
    return q;
  }
  window.imods = window.imods || {};
  // Implement-A A3 (work order, 2026-10-01): an order number (MA147, MA147LL/A) opens the refurbished listing that carries it
  // (#imods-order-lookup, read from the for-sale collections' titles; an available listing first)
  window.imods.findListing = function (q) {
    var el = document.getElementById('imods-order-lookup'), list = [];
    try { list = el ? JSON.parse(el.textContent) : []; } catch (e) { list = []; }
    var k = norm(q), best = null;
    list.forEach(function (o) { if (o[0] === k && (!best || (!best[2] && o[2]))) best = o; });
    return best ? { number: k, url: best[1], available: best[2] } : null;
  };
  window.imods.findModel = function (q) {
    var L = lookup(); if (!L) return null;
    var k = norm(q);
    var keys = L.n[k] || (L.n[k.replace(/LL\/A$/, '')] || null);
    if (!keys) return { query: q, keys: [] };
    return { query: q, number: k, keys: keys, models: keys.map(function (x) { return Object.assign({ key: x, hint: L.hints[x] || '' }, L.m[x]); }) };
  };
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-im-finder]');
    if (!f) return;
    var inp = f.querySelector('input[name="q"]'); var out = f.querySelector('[data-im-finder-result]');
    var r = window.imods.findModel(inp && inp.value);
    if (!r || !r.keys.length) return; // not a model number: the normal search runs (part names, product names)
    e.preventDefault();
    var esc = window.imods.esc, mode = f.getAttribute('data-im-finder');
    var h = '', go = '';
    var li = mode !== 'pick' ? window.imods.findListing(inp && inp.value) : null;
    if (r.models.length === 1) {
      var m = r.models[0];
      h = '<p class="im-finder__match"><b>Your iPod: ' + esc(m.s) + ' (' + esc(m.no) + ')</b></p>';
      // Implement-A A3: a model number opens its parts and repair page; the refurbished link stays as a second line
      if (mode !== 'pick') {
        go = li ? li.url : m.parts;
        h += '<p class="im-finder__links"><a class="im-link" href="' + esc(go) + '">' + (li ? 'Opening the ' + esc(li.number) + ' listing' : 'Opening parts and repair') + '</a></p>'
          + '<p class="im-caption">' + (li ? 'Parts and repair: <a class="im-link" href="' + m.parts + '">' + esc(m.s) + '</a>' : 'Looking to buy one? <a class="im-link" href="' + m.sale + '">Refurbished for sale</a>') + '</p>';
      }
      window.imods.yours && window.imods.yours.set({ key: m.key, label: m.s });
    } else {
      h = '<p class="im-finder__match"><b>Your iPod: ' + esc(r.models[0].s) + ' or ' + esc(r.models[1].s) + ' (' + esc(r.models[0].no) + ').</b> Not sure? <a class="im-link" href="/pages/identify-your-ipod">Identify your iPod</a></p><ul class="im-finder__hints">' +
        r.models.map(function (m) { return '<li>' + esc(m.hint) + (mode !== 'pick' ? ' <a class="im-link" href="' + m.parts + '">Parts and repair</a>' : '') + '</li>'; }).join('') + '</ul>';
    }
    if (out) { out.innerHTML = h; out.hidden = false; }
    f.dispatchEvent(new CustomEvent('imods:found', { bubbles: true, detail: r }));
    if (go) window.location.assign(go);
  });
})();
